import React, { Component } from 'react';
import { AuthContext } from "../../components/Auth/AuthDataProvider.jsx";
import apiUtil from "../../api/apiUtil.jsx";
import api from "../../api/api.jsx";
import ldsApi from "../../api/ldsApi.jsx";
import moment from 'moment';
import { Container, Row, Col, Button, Card, ToggleButton, ToggleButtonGroup, Form, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CustomDialog2 from '../../components/Dialog/CustomDialog2.jsx';
import { faDownload, faMagnifyingGlass, faPlus, faWarning, faPlusCircle, faChevronLeft , faChevronRight, faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons'
import { 
  Stepper, 
  Step, 
  StepLabel,
  Box,
  CircularProgress,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core';
import Filterimg from '../../assets/img/icons/filter.png';
import PickUpArrow from '../../assets/img/allocation/pickup-arrow.png';
import BlackBox from '../../assets/img/allocation/black-box.png';
import RedClock from '../../assets/img/allocation/red-clock.png';
import DropOffArrow from '../../assets/img/allocation/drop-off-arrow.png';
import PickUpBox from '../../assets/img/allocation/pickup-box.png';
import DeliveryBox from '../../assets/img/allocation/delivery-box.png';
import SavingLoad from '../../assets/img/allocation/saving-load.png';

import { ReactComponent as BlueCalendar } from '../../assets/img/allocation/blue-calendar.svg';
import { ReactComponent as ArrowDownIcon } from '../../assets/img/left_menu/arrow-down.svg';
import { ReactComponent as StepTrue } from '../../assets/img/allocation/step-true.svg';
import { ReactComponent as BoxPlus } from '../../assets/img/allocation/box-plus.svg';
import { ReactComponent as GreyClock } from '../../assets/img/allocation/grey-clock.svg';
import { ReactComponent as SavedLoad } from '../../assets/img/allocation/saved-load.svg';
import { ReactComponent as ErrorLoad } from '../../assets/img/allocation/error-load.svg';

import Table from '../../components/Table/allocationTable.jsx';
import CustomAutosuggest from '../../components/CustomFields/CustomAutosuggest.jsx';
import CustomInput from '../../components/CustomFields/CustomInput.jsx';

import CustomButton from '../../components/CustomFields/CustomButton.jsx';
import CustomDialog from '../../components/Dialog/CustomDialog.jsx';
import DropdownMenu from '../../components/Dropdown/DropdownMenuFilter.jsx';
import JobPreviewDialog from '../Jobs/Partial/JobPreviewDialog.jsx';
import OrderDetailForm from '../Dashboard/OrderDetailForm';
import {RoleAccessService} from '../../data/role-access'; 
import _ from "lodash";

const { 
  REACT_APP_JOB_UPDATE_SOCKET_URL,
  REACT_APP_LDS_API_URL,
} = process.env;

 
class Allocation extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props); 
    
    this.pageName = 'jobList';
    
    let getDate = localStorage.getItem("allocation_date");
    
    let allocationDate = null;
    if(getDate != '' && getDate != null) {
      allocationDate = getDate;
    } else {
      allocationDate = moment();
    }
    
    let rangeDate = {
      startDate: moment(),
      endDate: moment(),
    };
    
    this.state = {
      steps: [
      { number: 1, label: "Verify Packages" },
      { number: 2, label: "Confirm Pickups" },
      { number: 3, label: "Microsite" },
      { number: 4, label: "Assign Drivers" },
      ],
      activeStep: 0,
      data: [],
      oldData: [],
      isLoading: false,
      grantedAccess : new RoleAccessService(),
      currentRole: window.localStorage.getItem('current_role') || null,
      user: JSON.parse(localStorage.getItem('user')),
      rangeDate: rangeDate,
      startDate: allocationDate,
      endDate: allocationDate,
      status: [],
      order_status: null,
      status_total: 0,
      tableStatus: [],
      searched: '',
      hiddenColumns: [],
      preview_data: [],
      openPackageDialog: false,
      preview_detail: null,
      preview_index: null,
      openPreviewDialog: false,
      openPreviewDialogItem: null,
      workerItems: [],
      vendorItems: [],
      randomColor: [],
      search_text: '',
      batch_pickup_ids: [],
      total_orders_count: 0,
      savingLoad: false,
      savedLoad: false,
      errorLoad: false,
      timeWindowCound: 0,
      missingPackageCount: 0,
      total_load_volume_list: null
    }
  }
  

  componentDidMount() {
    this.callInitApis();
    
    this.callManpowerDriverReadApi('', (arr) => {
      this.setState({
        workerItems: arr.sort((a, b) => {
          const nameA = a.label?.toUpperCase(); // ignore upper and lowercase
          const nameB = b.label?.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
        
          // names must be equal
          return 0;
          })
        });
      });
      // this.callVendorReadApi('', (arr) => {
      //   driver.push(arr);
      //   var result = [].concat.apply([],Object.values(driver));
      //   this.setState({
      //     workerItems: result.sort((a, b) => {
      //       const nameA = a.label?.toUpperCase(); // ignore upper and lowercase
      //       const nameB = b.label?.toUpperCase(); // ignore upper and lowercase
      //       if (nameA < nameB) {
      //         return -1;
      //       }
      //       if (nameA > nameB) {
      //         return 1;
      //       }
      //     
      //       // names must be equal
      //       return 0;
      //     })
      //   }, () => {
      //     this.setState({
      //       oldWorkerItems: this.state.workerItems
      //     });              
      //   });
      // });
  }

  callInitApis = () => {
    this.loadStatusApi(()=> {
        this.callReadApi();
    });
  }

  loadStatusApi = (callback = null) => {
    this.callStatusApi((data, total) => {
      if(data && data.length > 0){
        let order_status = this.state.order_status;
        let status = [];
        data.map((item, i) => {
          if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "assign-pending" || item.status_details.status.replace(' ', '-').trim().toLowerCase() == "on-hold") {
            return status.splice(1, 0, {
              order: 7,
              id: item.status_details.id,
              status: "On Hold",
              text: "On Hold",
              total: item.total_job,
            });
            // status[0].push(objectVal)
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "not-assigned") {
            order_status = order_status  ? `${order_status},${ item.status_details.id}`: item.status_details.id;
            return status.splice(2, 0, {
              order: 1,
              id: item.status_details.id,
              status: "Pending",
              text: "Pending",
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "assigned") {
            // order_status = order_status ? `${order_status},${ item.status_details.id}`: item.status_details.id;
            return status.splice(3, 0, {
              order: 2,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "acknowledged") {
            return status.splice(4, 0, {
              order: 3,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "in-progress") {
            return status.splice(5, 0, {
              order: 4,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "completed") {
            return status.splice(6, 0, {
              order: 5,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "failed") {
            return status.splice(7, 0, {
              order: 6,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "cancelled") {
            return status.splice(8, 0, {
              order: 8,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replace(' ', '-').trim().toLowerCase() == "self-collect") {
            return status.splice(9, 0, {
              order: 9,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          } else if(item.status_details.status.replaceAll(' ', '-').trim().toLowerCase() == "assigned-to-vendor") {
            // order_status = order_status  ? `${order_status},${ item.status_details.id}`: item.status_details.id;
            return status.splice(9, 0, {
              order: 9,
              id: item.status_details.id,
              status: item.status_details.status,
              text: item.status_details.status,
              total: item.total_job,
            });
          }
        });
  
        status = status.sort(function(a, b) {
          return (a.order - b.order);
        });
        let tableStatus = status;
        status.unshift({
          id: 0,
          status: 'Total Orders',
          total: total,
          
        });
  
        this.setState({
          status: status,
          status_total: total,
          tableStatus: tableStatus,
          order_status: order_status,
        }, () => {
          if(callback) {
            callback();
          }
        });
      } else {
        if(callback) {
          callback();
        }
      }
    });
  }

  /* API */
  callStatusApi = (callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      let startDate = moment(this.state.rangeDate && this.state.rangeDate.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = moment(this.state.rangeDate && this.state.rangeDate.endDate).format(apiUtil.getDefaultDateFormat());

      let param = {
        start_date: startDate,
        end_date: endDate,
      };

      ldsApi.read('orders/job/stats', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            if(data && data.result){
              let total = data.total_delivery;
              let result = Object.keys(data.result).map((k) => data.result[k]);
              
              if(result && result.length > 0){
                this.setState({
                  isLoading: false,
                }, () => {
                  if(callback){
                    callback(result, total);
                  }
                });
              } else {
                this.setState({
                  isLoading: false,
                }, () => {
                  if(callback){
                    callback(null, 0);
                  }
                });
              }
            } else {
              this.setState({
                isLoading: false,
              }, () => {
                if(callback){
                  callback(null, 0);
                }
              });
            }
          }, (error, type) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(null, 0);
              }
            });
          });
      });
    });
  }

  callReadApi = (search = '', callback = null) => {
    const { accessToken } = this.context;
    
    this.setState({
      isLoading: true
    }, () => {
      let startDate = moment(this.state.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = startDate;
      let param = {
        search: this.state.searched ? this.state.searched.trim() : this.state.searched,
        order_status: this.state.order_status,
        allocation_step: 1,
        start_date: startDate,
        end_date: endDate,
        sort: "latest",
        group_by: this.state.activeStep == 0 ? "customer" : this.state.activeStep == 1 ? "postal_code" : null
      };
      
      // if(order)
      ldsApi.read('allocation/orders_v2', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            if(this.state.activeStep == 0 || this.state.activeStep == 1) {
              data.result.forEach(obj => {
                obj.open = true;
                obj.orders.sort((a, b) => {
                  if (a.job_type < b.job_type) {
                    return -1;
                  }
                  if (a.job_type > b.job_type) {
                    return 1;
                  }
                  return 0;
                });
              });
            }
            
            if(callback){
              callback(data.result);   
            }

            this.setState({
              data: data.result ? data.result : [],
              oldData: data.result ? data.result : [],
              total_orders_count: data.result.reduce((acc, obj) => acc + obj.orders.length, 0),
              isLoading: false,
              savingLoad: false,
              savedLoad: false,
              errorLoad: false,
              search_text: ''
            },() => {
              this.setState({
                timeWindowCound: this.getNotDefaultTimeWindowCount(),
                missingPackageCount: this.getMissingPackagesCount()
              });                  
            });
            // this.loadStatusApi();
          }, (error, type) => {
            if(callback){
              callback([]);   
            }
            this.setState({
              data: [],
              oldData: [],
              isLoading: false,
              errorLoad: true
            });
          });
      });
    });
  }

  callUpdateIsActiveApi = (row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      ldsApi.update('orders/' + row.id, row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback();
              }
            });
          }, (error, type) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback();
              }
            });
          });
      });
    });
  }

  callDeleteApi = (row,indexNum=null, callback = null) => {
    const { accessToken } = this.context;
    this.setState({
      isLoadingDelete:true,
    })
   
      let param = {
        destroy_all: true,
        allocation: true,
      };
      let selectedRow = row;
      let ids = '';
  
      selectedRow.map((item, i) => { ids += item.id +','; });


      ids = ids.slice(0, -1);
      if ((selectedRow.length > 0)) {
        ldsApi.delete('delete/orders/multiple?id=' + ids, param, accessToken)
          .then((result) => {
            apiUtil.parseResult(result, (data) => {
              this.setState({
                isLoadingDelete:false,
              })
              if(callback){
                callback();
              }
            }, (error, type) => {
              if(indexNum != null) {
                this.state.data[indexNum].orders.map((obj) => {
                  obj.tableData.checked = false;
                  obj.is_selected = false;
                });
                this.state.data[indexNum].is_selected = false;
              }
              this.setState({ 
                openDeleteDialog: false,
                isLoadingDelete:false,
                data: this.state.data
              }, ()=> {
                //this.state.data.map(dd => dd.is_selected == true ? dd.is_selected = false : dd.is_selected)
                //this.setState({
                //  data : this.state.data
                //})
              });  
              
              this.doDialogOrder = null;
              apiUtil.toast(
                error,
                "check_circle"
              );
            });
        });
      }
  }
  
  callBulkDeleteApi = (row, callback = null) => {
    const { accessToken } = this.context;
    
    this.setState({
      isLoading:true,
    })
   
    let param = {
      destroy_all: true,
      allocation: true
    };
    let selectedRow = row;
    let ids = '';
  
    selectedRow.map((item, i) => { ids += item.id +','; });


    ids = ids.slice(0, -1);
    if ((selectedRow.length > 0)) {
      ldsApi.delete('delete/orders/multiple?id=' + ids, param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading:false,
            })
            if(callback){
              callback();
            }
          }, (error, type) => {

            this.setState({ 
              isLoading:false,
              openDeleteDialog: false,
            });  
            
            this.doDialogOrder = null;
            apiUtil.toast(
              error,
              "check_circle"
            );
          });
      });
    }
  }

  deleteDialog = () => {
    let check_duplicate = null
    this.DoDialogOrder && this.DoDialogOrder.orders && this.DoDialogOrder.orders.map((dd) => 
      dd.do_number.includes("-DULP") ? check_duplicate = true : null
    )
    return <Modal centered show={this.state.openDeleteDialog} onHide={() => {
            this.setState({
              openDeleteDialog: false,
            });
            }}>
            <Modal.Header className="p-4" closeButton>
            <div className="text-center font-medium fs-5 d-flex justify-content-center w-100">Are you sure?</div>
            </Modal.Header>
            <div className="justify-content-center p-4">
              { !check_duplicate? 
                <div className="text-center mb-4">This is <span className="text-danger">NOT</span> a duplicated job. Deleting this job will permanently remove the job from the dashboard. Continue?</div>
                : <div className="text-center mb-4">Delete this duplicated job?</div>
              }
            <div className="d-flex justify-content-center">
              <Button variant="secondary" className="mx-2 px-4 py-2 border-delete-b" onClick={() => {
                this.setState({
                  openDeleteDialog: false,
                });
              }}>
                Cancel
              </Button>
              <Button variant="primary" className="mx-2 px-4 py-2 border-delete" 
              disabled={this.state.isLoadingDelete}
              onClick={() => {
                  let row = this.DoDialogOrder.orders;
                  let indexNum = this.DoDialogOrder.indexNum;
                    this.sendJsonData(true);
                    this.callDeleteApi(row,indexNum, () => {
                      apiUtil.toast('Successfully Deleted', 'check_circle');
                      this.setState({
                        openDeleteDialog: false,
                      }, ()=> {
                        this.DoDialogOrder = null;
                      })
                      setTimeout(() => {
                        window.location.reload();    
                      },2000);                    
                    })
                }}>
                Delete
              </Button>
            </div>
            </div>
          </Modal>
  }
  
  bulkDeleteDialog = () => {
    return <Modal centered show={this.state.openBulkDeleteDialog} onHide={() => {
            this.setState({
              openBulkDeleteDialog: false,
            });
            }}>
            <Modal.Header className="p-4" closeButton>
            <div className="text-center font-medium fs-5 d-flex justify-content-center w-100">Are you sure?</div>
            </Modal.Header>
            <div className="justify-content-center p-4">
              Deleting this job will permanently remove the job from the dashboard. Continue?
              <div className="d-flex justify-content-center mt-4">
                <Button variant="secondary" className="mx-2 px-4 py-2 border-delete-b" onClick={() => {
                  this.setState({
                    openBulkDeleteDialog: false,
                  });
                }}>
                  Cancel
                </Button>
                <Button variant="primary" className="mx-2 px-4 py-2 border-delete" 
                onClick={() => {
                    let row = [];
                    let selected_orders = this.state.data.filter(obj => obj.is_selected == true)
                    let is_collection_selected = []
                    let inner_selected_order = []
                    let unselected_selected_order = []
                    let is_has_vendor_order = [];
                    let alert_message = '';
                    let has_issue = false
                    

                    selected_orders.map((obj) => {                       
                       is_has_vendor_order = obj.orders.filter(obj => obj.application_company_id != this.state.user.owner_info.application_company_id);
                       is_collection_selected = obj.orders.filter(obj => obj.job_type == 'Collection' && obj.is_selected && obj.is_selected == true);
                       inner_selected_order = obj.orders.filter(obj => obj.is_selected && obj.is_selected == true);
                       if(is_has_vendor_order.length > 0) {
                         apiUtil.toast('Please check with Operations for changes', 'check_circle');
                         has_issue = true; 
                       }else if(is_collection_selected.length > 0 && obj.orders.length != inner_selected_order.length) {                                              
                         apiUtil.toast('Please delete Delivery order(s) before the Pick Up Order '+is_collection_selected[0].order_number, 'warning', 'error'); 
                         alert_message = '';
                         has_issue = true;                         
                       } else {
                         row = [...row,...inner_selected_order];                                          
                       }
                       
                    });

                    if(has_issue == false) {           
                      this.sendJsonData(true);                    
                      this.callBulkDeleteApi(row, () => {
                        apiUtil.toast('Successfully Deleted', 'check_circle');
                        setTimeout(() => {
                          window.location.reload();    
                        },2000);  
                      })                                           
                    }
                    this.setState({
                      openBulkDeleteDialog: false,
                    })
                  }}>
                  Delete
                </Button>
              </div>
            </div>
          </Modal>
  }

  duplicateDialog = () => {
    let company_name = this.DoDialogOrder && this.DoDialogOrder.company_name
    let vendor = this.DoDialogOrder && this.DoDialogOrder.orders.filter((obj) => obj.application_company_id != this.state.user.owner_info.application_company_id);
    return <Modal centered show={this.state.openDuplicateDialog} onHide={() => {
            this.setState({
              openDuplicateDialog : false,
            });
            }}>
            <Modal.Header className="p-4" closeButton>
            <div className="text-center font-medium fs-5 d-flex justify-content-center w-100">Are you sure?</div>
            </Modal.Header>
            <div className="justify-content-center p-4">
            <div className="text-center mb-4">This will put your <span className="font-medium">{this.DoDialogOrder && this.DoDialogOrder.orders && this.DoDialogOrder.orders.length}</span> selected jobs into a new cluster {(vendor && vendor.length > 0 || company_name == 'No Customer') ? '' : 'for ' }<span className="font-medium">{(vendor && vendor.length > 0 || company_name == 'No Customer') ? '' : company_name }</span></div>
            <div className="d-flex justify-content-center">
              <Button variant="secondary" className="mx-2 px-4 py-2 buttom-primary-dailog-cancel" onClick={() => {
                this.setState({
                  openDuplicateDialog: false,
                });
              }}>
                Cancel
              </Button>
              <Button variant="primary" className="mx-2 px-4 py-2 buttom-primary-dailog" 
                disabled ={this.state.isLoading ? true : false}
                onClick={() => {
                  let customData = this.DoDialogOrder.orders;
                  let indexNum = this.DoDialogOrder.indexNum;
                  let is_deli_only = this.state.data[indexNum].orders.filter((obj) => obj.job_type == 'Collection' && obj.is_selected);
                  let pending_id = this.state.tableStatus.filter((order_status) => order_status.status == 'Pending')[0].id;
                  let org_data = _.cloneDeep(this.state.data[indexNum].orders);
                  if(vendor.length > 0 && !is_deli_only.length > 0) {
                    customData = this.state.data[indexNum].orders;
                  }

                  customData.map((order) => {
                    if(vendor.length > 0) {
                      order['amount'] = 0.00
                      order['driver_payout'] = 0.00
                      order['vendor_payout'] = 0.00
                      order['order_status'] = null;                    
                      order['vendor_id'] = null;
                      order['order_status_id'] = pending_id;      
                      order['company_name'] = null; 
                      order['customer_id'] = null;                   
                    }
                    
                    order.prev_id = order.id;
                    ['id','order_number','order_status','extra_workers','uploader','reference_no', 'department'].forEach(e => delete order[e]);
                    order.drop_off_date = moment(order.drop_off_date).format("YYYY-MM-DD");
                    order.is_duplicate = true;
                    order.is_assigned_mail_sent = false;
                    order.is_assigned_sms_sent = false
                    order.is_calculate = true;
                    order.job_steps = [{job_step_id: null}]
                    order.route_weight = null;
                    order.group_name = null;
                    order.order_packages.map((pack, index) => {
                      if (pack.package_id === 1) {
                        delete pack['created_at'];
                        delete pack['updated_at'];
                        delete pack['application_company_id'];
                        delete pack['order_id'];
                        delete pack['id'];
                        order.order_packages[index]['name'] = 'XS'
                        order.xs_packages =  order.order_packages[index]['package_quantity']
                      }
                      if (pack.package_id === 2) {
                        delete pack['created_at'];
                        delete pack['updated_at'];
                        delete pack['application_company_id'];
                        delete pack['order_id'];
                        delete pack['id'];
                        order.order_packages[index]['name'] = 'S'
                        order.s_packages =  order.order_packages[index]['package_quantity']
                      }
                      if (pack.package_id === 3) {
                        delete pack['created_at'];
                        delete pack['updated_at'];
                        delete pack['application_company_id'];
                        delete pack['order_id'];
                        delete pack['id'];
                        order.order_packages[index]['name'] = 'M'
                        order.m_packages =  order.order_packages[index]['package_quantity']
                      }
                      if (pack.package_id === 4) {
                        delete pack['created_at'];
                        delete pack['updated_at'];
                        delete pack['application_company_id'];
                        delete pack['order_id'];
                        delete pack['id'];
                        order.order_packages[index]['name'] = 'L'
                        order.l_packages =  order.order_packages[index]['package_quantity']
                      }
                      if (pack.package_id === 5) {
                        delete pack['created_at'];
                        delete pack['updated_at'];
                        delete pack['application_company_id'];
                        delete pack['order_id'];
                        delete pack['id'];
                        order.order_packages[index]['name'] = 'Pallet'
                        order.pallets =  order.order_packages[index]['package_quantity']
                      }
                      if (pack.package_id === 6) {
                        delete pack['created_at'];
                        delete pack['updated_at'];
                        delete pack['application_company_id'];
                        delete pack['order_id'];
                        delete pack['id'];
                        order.order_packages[index]['name'] = 'Oversized Package'
                        order.oversized_packages =  order.order_packages[index]['package_quantity']
                      }
                    })
                  });
                  customData.sort((a,b) =>  a.job_type - b.job_type )
                  this.callCreateApi(customData, (result) => {
                    let orders = [];
                    if(result.status) {
                      this.state.data[indexNum].orders = org_data;
                      this.setState({
                        data: this.state.data  
                      },() => {
                        // let sorted_data = result.saved_orders && result.saved_orders.sort((a,b) => {if (a.orders['0']["id"] > b.orders['0']["id"]) { return -1 } else {return 1}})
                        orders = result.saved_orders.sort((a, b) => a.job_type.localeCompare(b.job_type));
                        
                        let driverpayout = 0 
                        result.saved_orders.map((order) => {
                          let driverPayout = 0;
                          if(order.driver_payout != null) {                       
                            driverpayout = driverpayout + parseFloat(order.driver_payout)
                          }
                        })
                        this.state.data[indexNum].orders.map((obj) => {
                            obj.tableData.checked = false;
                            obj.is_selected = false;
                        });
                        let checkCol = orders.filter((obj) => obj.job_type == 'Collection')
                        let addCol = this.state.collection_do_number.concat(checkCol)
                        this.setState({
                          collection_do_number: addCol,
                        })
                        if(checkCol.length > 0) {
                          let data = [{is_selected: false,company_name: (vendor.length > 0 ? 'No Customer' : this.DoDialogOrder.company_name), orders: orders, driver_name: (vendor.length > 0 ? '' : this.DoDialogOrder.driver_name), driver_payout: driverpayout}];
                          this.setState({ 
                            data: [...data,...this.state.data]
                          }, ()=> {
                            this.state.data.map(dd => dd.is_selected == true ? dd.is_selected = false : dd.is_selected)
                            this.setState({
                              data : this.state.data
                            })
                          });                            
                        } else {
                          let order_driver_payout = 0
                          orders.map((dd) => {order_driver_payout = dd.driver_payout != null ? parseFloat(order_driver_payout) + parseFloat(dd.driver_payout) : 0})
                          let data = this.state.data
                          data[indexNum].is_selected = false;
                          data[indexNum].driver_payout = order_driver_payout != NaN ? parseFloat(this.state.data[indexNum].driver_payout) + parseFloat(order_driver_payout) : 0.00;
                          data[indexNum].orders = [...this.state.data[indexNum].orders,...orders];
                          this.setState({
                            data: data
                          });  
                          this.tableOrders = this.state.data[indexNum].orders;                        
                        }                          
                        });
                        
                    }
                    this.setState({
                      openDuplicateDialog: false,
                      isLoading: false,
                    }, () => {
                      apiUtil.toast('Successfully Updated', 'check_circle');
                      this.sendJsonData(true);
                      this.DoDialogOrder = null;
                      setTimeout(() => {
                        window.location.reload();    
                      },2000);  
                    });
                  });
                }}>
                Confirm
              </Button>
            </div>
            </div>
          </Modal>
  }
  /*End Mass Delete Api*/

  callUpdateStatusApi = (row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      ldsApi.create('orders/assign/order', row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            let result = (data.result && data.result.length > 0) ? data.result[0] : null;
            this.loadStatusApi()
            if(result){
              this.setState({
                isLoading: false,
              }, () => {
                if(callback){
                  callback(result);
                }
              });
            } else {
              this.setState({
                isLoading: false,
              }, () => {
                if(callback){
                  callback(null);
                }
              });
            }
          }, (error, type) => {
            if(error && error.email && error.email.length > 0){
              apiUtil.toast(error.email[0], 'warning', 'error');
            } else if(error && error !== ''){
              apiUtil.toast(error, 'warning', 'error');
            }
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(null);
              }
            });
          });
      });
    });
  }
  /* END API */

  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (this.state.do_numbers == null) {
      this.setState({
        selectedDoNumberValidated: true,
        openDialogBatchUpdate : true,
        collection_erference_no: null,
        do_numbers: null,
      });
    } else if (this.state.collection_erference_no == null) {
      this.setState({
        collection_erference_noValidated: true,
        openDialogBatchUpdate : true,
      });
    } else {
      let selected_do_number = this.state.do_numbers.replace(/\n|\r|,/g, ",")
      selected_do_number = selected_do_number.split(",").map(str => str.trim()).join(",") // trim individual words and join with commas
      let data = {
        delivery_do : selected_do_number,
        collection_reference : this.state.collection_erference_no ,
      }
      this.callUpdateDoApi(data, (row) => {
        this.setState({
          collection_erference_no: null,
          do_numbers : null,
          openDialogBatchUpdate : false,
        });
        this.callInitApis();
      });
    }
  }

  customDialogBatchUpdate = () => {
    return <Modal centered show={this.state.openDialogBatchUpdate} onHide={() => {
      this.setState({
        openDialogBatchUpdate : false,
        collection_erference_no: null,
        selectedDoNumberValidated: false,
        do_numbers: null,
      });
      }} className="width-modal">
      <Modal.Header className="p-4" closeButton>
      <div className="text-center font-medium fs-5 d-flex justify-content-start w-100">Change Pick Up</div>
      </Modal.Header>
      <div className="justify-content-center p-4">
      <Container fluid>
        <Row className="p-4">
         <Col xs={12} md={12} className="d-flex py-2 max-xs-width-control-900">
           <div className="max-xs-width-control-900 w-25 px-3 text-end font-medium">D.O Number *</div>
          <div className="w-75 max-xs-width-control-900">
           <textarea className='form-control w-100' rows="5"
          value={this.state.do_numbers}
          onChange={e => {
            this.setState({
                do_numbers: e.target.value.replace(/[,]/g, ""),
            })
          }}
          />
          {this.state.selectedDoNumberValidated && <span style={{color:"red"}}>Do Number(s) are required<br/><br/></span>}
          <span style={{fontSize: '10px'}}>Copy and paste / enter / DO number into the box. One D.O. No. per line.</span>
          </div>
          </Col>
          <Col xs={12} md={12} className="d-flex py-2 max-xs-width-control-900">
            <div className="w-25 px-3 text-end max-xs-width-control-900 font-medium">New Pick Up Ref DO</div>
            <div className="w-50 d-flex justify-content-start max-xs-width-control-900 flex-column">
            <select className="max-xs-width-control-900 form-control ms-2" style={{width:"100%", border: "1px solid #E0E1E4", borderRadius: "4px",padding:"", backgroundColor: 'transparent'}}
                placeholder={'Select pick up reference here...'}
                value={this.state.collection_erference_no}
                native
                disableUnderline
                error={this.state.collection_erference_noValidated}
                onChange={(e) => {
                  this.setState({
                    collection_erference_no: e.target.value
                  })
                }}
              >
          <option value="" selected> Select Pick Up Reference </option>
          {this.state.collection_do_number && this.state.collection_do_number.map((dd, index)=> 
            <option value={dd.order_number}>{dd.order_number}</option>
          )}
        </select>
        {this.state.collection_erference_noValidated && <span style={{color:"red"}}>Select Pick Up Reference<br/><br/></span>}
        {/* <input type="text" value={department} className="form-control ms-2" disabled/> */}
            </div>
          </Col>
        </Row>
      </Container>
      <div className="d-flex justify-content-center">
        <Button variant="secondary" className="mx-2 px-4 py-2 buttom-primary-dailog-cancel" onClick={() => {
          this.setState({
            openDialogBatchUpdate: false,
            collection_erference_no: null,
            selectedDoNumberValidated: false,
            do_numbers: null,
          });
        }}>
          Cancel
        </Button>
        <Button variant="primary" className="mx-2 px-4 py-2 buttom-primary-dailog" 
        disabled={this.state.do_numbers || this.state.collection_erference_no ? false : true}
        onClick={(e) => {
             this.setState({
              openDialogBatchUpdateConfirm: true,
              openDialogBatchUpdate: false,
             })
          }}>
          Save Changes
        </Button>
      </div>
      </div>
    </Modal>
    
  }

  dialogBatchUpdateConfirm = () => {
    let company_name = this.DoDialogOrder && this.DoDialogOrder.orders &&  this.DoDialogOrder.orders['0'].customer &&  this.DoDialogOrder.orders['0'].customer.company_name
    return <Modal centered show={this.state.openDialogBatchUpdateConfirm} onHide={() => {
            this.setState({
              openDialogBatchUpdateConfirm : false,
              collection_erference_no: null,
              do_numbers: null,
            });
            }}>
            <Modal.Header className="p-4" closeButton>
            <div className="text-center font-medium fs-5 d-flex justify-content-center w-100">Are you sure?</div>
            </Modal.Header>
            <div className="justify-content-center p-4">
            <div className="text-center mb-4">Make sure all your delivery points are tied to the correct pick up points. Any pick up that do not have delivery points will not be reflected in the subsequent steps.</div>
            <div className="d-flex justify-content-center">
              <Button variant="secondary" className="mx-2 px-4 py-2 buttom-primary-dailog-cancel" onClick={() => {
                this.setState({
                  openDialogBatchUpdateConfirm: false,
                  collection_erference_no: null,
                  do_numbers: null,
                });
              }}>
                Cancel
              </Button>
              <Button variant="primary" className="mx-2 px-4 py-2 buttom-primary-dailog" onClick={(e) => {
                this.setState({
                  openDialogBatchUpdateConfirm: false,
                  collection_erference_no: null,
                  do_numbers: null,
                });
                this.handleSubmit(e);
                }}>
                Confirm
              </Button>
            </div>
            </div>
          </Modal>
  }

  callMassUpdateStatusApi = (row, callback = null) => {
    const { accessToken } = this.context;
    //console.log(row.data[0])
    if (!row.data[0].id.length > 0) {
      apiUtil.toast('You must select order!', 'warning');
      return
    }
    this.setState({
      isLoading: true
    }, () => {
      ldsApi.create('orders/assign/order', row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            let result = (data.result && data.result.length > 0) ? data.result : null;
            this.loadStatusApi()
            if(result){
              this.setState({
                isLoading: false,
              }, () => {
                if(callback){
                  callback(result);
                  this.callReadApi();
                }
              });
            } else {
              this.setState({
                isLoading: false,
              }, () => {
                if(callback){
                  callback(null);
                }
              });
            }
          }, (error, type) => {
            this.setState({
              isLoading: false,
              openDialogChangePayout: false,
              openDialogUnassign: false
            }, () => {
              if(callback){
                callback(null);
              }
            });
          });
      });
    });
  }
  
  /* Driver Assign API */
  callDriverAssignApi = (data, callback = null) => {
    const { accessToken } = this.context;

    let row = {}
    row.data = []
    row.data.push(data)

    this.setState({
      isLoading: true
    }, () => {
        ldsApi.create('orders/assign/order', row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            if(callback){
              callback(data);
            }
          }, (error, type) => {
            if(error && error !== ''){
                apiUtil.toast(error, 'warning', 'error');
            }
            
            if(callback){
              callback(null);
            }
          });
      });
    });
  }
  /* END API */

  /* WORKER API */
  callWorkerDriverReadApi = (search = '', callback = null) => {
    const { accessToken } = this.context;

    let param = {
      // page: 1,
      disabled: false,
      // take: apiUtil.getDefaultPageSize(),
      is_active: true,
      search: search ? search.trim() : search,
      is_truck_driver: true,
      // require_worker_only: true,
      light_data: true,
    };

    api.read('workers', param, accessToken)
      .then((result) => {
        apiUtil.parseResult(result, (data) => {
          let result = (data.result && data.result.length > 0) ? data.result : [];

          let arr = [];
          if(result && result.length > 0){
            arr = result.map((item, i) => {
              let value = item.id;
              let label = ((item.first_name && item.first_name !== '') ? item.first_name : '') + ' ' + ((item.last_name && item.last_name !== '') ? item.last_name : '');

              if(arr.findIndex(x => x.value === value) === -1){
                return {
                  value: value,
                  label: label,
                  item: item
                }
              } else {
                return null;
              }
            });
            this.setState({
              workers: arr.sort((a, b) => {
                      const nameA = a.label?.toUpperCase(); // ignore upper and lowercase
                      const nameB = b.label?.toUpperCase(); // ignore upper and lowercase
                      if (nameA < nameB) {
                        return -1;
                      }
                      if (nameA > nameB) {
                        return 1;
                      }
                    
                      // names must be equal
                      return 0;
                    })
            })
            if(callback){
              callback(arr);
            }
            
          } else {
            if(callback){
              callback([]);
            }
          }
        }, (error, type) => {
          if(callback){
            callback([]);
          }
        });
    });
  }


  callManpowerDriverReadApi = (search = '', callback = null) => {
    const { accessToken } = this.context;

    let param = {
      // page: 1,
      // take: apiUtil.getDefaultPageSize(),
      disabled: false,
      is_active: true,
      search: search ? search.trim() : search,
      is_truck_driver: true,
      // require_worker_only: true,
      light_data: true
    };

    api.read('workers', param, accessToken)
    .then((result) => {
      apiUtil.parseResult(result, (data) => {
        let result = (data.result && data.result.length > 0) ? data.result : [];

        let arr = [];
        if(result && result.length > 0){
          arr = result.map((item, i) => {
            let value = item.id;
            let label = ((item.first_name && item.first_name !== '') ? item.first_name : '') + ' ' + ((item.last_name && item.last_name !== '') ? item.last_name : '');

            if(arr.findIndex(x => x.value === value) === -1){
              return {
                value: value,
                label: label,
                item: item
              }
            } else {
              return null;
            }
          });
  
          if(callback){
            callback(arr);
          }
        } else {
          if(callback){
            callback([]);
          }
        }
      }, (error, type) => {
        if(callback){
          callback([]);
        }
      });
    });
  }
  /* END WORKER API */
  
  /* VENDOR API */
  callVendorReadApi = (search = '', callback = null) => {
    const { accessToken } = this.context;

      let param = {
        page: 1,
        take: apiUtil.getDefaultPageSize(),
        is_active: true,
      };

      api.read('vendors/active_vendor', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            let result = (data.result && data.result.length > 0) ? data.result : [];

            let arr = [];
            if(result && result.length > 0){
              arr = result.map((item, i) => {
                let value = item.company_id;
                let label = item.company_name &&  item.company_name;

                if(arr.findIndex(x => x.value === value) === -1){
                  return {
                    value: value,
                    label: label,
                    item: item
                  }
                } else {
                  return null;
                }
              });
      
              // this.setState({
              //   vendors: arr,
              // }, () => {
                if(callback){
                  callback(arr);
                }
              // });
            } else {
              // this.setState({
              //   vendorItems: [],
              // }, () => {
                if(callback){
                  callback([]);
                }
              // });
            }
          }, (error, type) => {
            // this.setState({
            //   vendorItems: [],
            // }, () => {
              if(callback){
                callback([]);
              }
            // });
          });
      });
  }
  /* END VENDOR API */

  callDetailsApi = (id = '', callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      ldsApi.read('orders/' + id, null, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback((data && data.result) ? data.result : null, (data && data.sorted_order_details) ? data.sorted_order_details : []);
              }
            });
          }, (error, type) => {
            apiUtil.toast(error, 'warning', 'error'); 
            this.setState({
              isLoading: false,
            });
          });
      });
    });
  }


  



  callAllocationUpdateApi = (id, row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      ldsApi.update('allocation_groups/' + id, row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(data);
              }
            });
          }, (error, type) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback();
              }
            });
          });
      });
    });
  }

  isCollectionFailed = (deliOrder) => {
    return deliOrder.failed_collection ? deliOrder.failed_collection : false;
  }
 
  /* TABLE */
  customTable = (orders, index) => {
    const { isCustomerRequired } = this.context;

    if(!this.state.isLoading) {
      return <Table 
      containerRef={this.containerRef}
      ref={this.refTable}
      isLoading={this.state.isLoading}
      isDraggable={false}
      grouping={false}
      limit={20}
      type={'allocation'}
      total={orders.length}
      data={orders}
      defaultExpanded={true}
      selection={false}
      onPageChange={(page,limit) => {
      }}
      onSelectionChange={(rows, column)=>{
        let data = this.state.data;
        data[index]["is_selected"] = true;
        data[index]["orders"].map((obj) => {
          if(rows.filter((o) => o.order_number == obj.order_number).length > 0) {
            obj.is_selected = true
          } else {
            obj.is_selected = false    
          }          
        });
        this.setState({data})

        if (!(rows.length > 0)) {
          let data = this.state.data;
          data[index]["is_selected"] = false;
          data[index]["orders"].map((obj) => {
            obj.is_selected = false;     
          });
          this.setState({data})
        }
        this.rowData = rows;
      }}
      // Toolbar={this.customToolbar}
      // Row={this.customRow}
      columns={[
        { 
          title: "Tracker Number",
          field: "order_number",
          cellStyle: {
             minWidth: 160,
             maxWidth: 160,
          },
          hidden: this.state.hiddenColumns.includes('delivery_number'),
          render: (row, type) => {
            if(type === 'row'){
              return  (row && row.order_number && row.order_number !== '') ?  
              <span 
              className={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details') && this.isCollectionFailed(row) == false ? "linkable-place" : ""}
              style={{ width:150, overflowWrap: 'break-word', display:'inline-block'}}  
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}> {row.order_number} </span>: '';
            } else {
              return row;
            }
          }
        },
        { 
          title: "Trip Date",
          field: "drop_off_date",
          cellStyle: {
             minWidth: 120,
            maxWidth: 120,
          },
          hidden: this.state.hiddenColumns.includes('date'),
          render: (row, type) => {
            if(type === 'row'){
              return (row && row.drop_off_date && row.drop_off_date !== '') ? 
              <span style={{ width:100, overflowWrap: 'break-word', display:'inline-block'}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{moment(row.drop_off_date).format(apiUtil.getImportDateFormat()) }</span> : '';
            } else {
              return row;
            }
          }
        },
        ...(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'DO')) ? [{ 
          title: "D.O Number", 
          field: "do_number",
          cellStyle: {
            minWidth: 160,
            maxWidth: 160,
         },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('do_number'),
          render: (row, type) => {
            if(type === 'row'){
              return (row && row.do_number && row.do_number !== '') ? <span style={{ width:150, overflowWrap: 'break-word', display:'inline-block'}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{row.do_number.replace(/\s/g, '\u00A0')}</span> : '';
            } else {
              return row;
            }
          }
        }] : [],
        { 
          title: "Job Type", 
          field: "job_type",
          cellStyle: {
             minWidth: 120,
            maxWidth: 120,
          }, 
          sorting: false,
          hidden: this.state.hiddenColumns.includes('delivery_type'),
          render: (row, type) => {
            if(type === 'row'){
              return (row && row.job_type && row.job_type !== '') ? <span style={{ width:110, overflowWrap: 'break-word', display:'inline-block'}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{row.job_type == "Collection" ? 'Pick Up' : 'Delivery'}</span> : '';
            } else {
              return row;
            }
          }
        },
        { 
          title: "Project", 
          field: "is_project",
          cellStyle: {
            minWidth: 120,
            maxWidth: 120,
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('is_project'),
          render: (row, type) => {
            if(type === 'row'){
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.is_project !== null) ? `${row.is_project == true ? "yes" : "No"}` : "No"}</span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Category", 
          field: "period_of_delivery",
          cellStyle: {
             minWidth: 120,
            maxWidth: 120,
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('period_of_delivery'),
          render: (row, type) => {
            if(type === 'row'){
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.period_of_delivery !== null) ? `${row.period_of_delivery}` : ""}</span>
            } else {
              return row;
            }
          }
        },
        { 
          title: "Pick Up Ref (D.O)",
          field: "collection_reference",
          cellStyle: {
            minWidth: 160,
            maxWidth: 160,
         }, 
          sorting: false,
          hidden: this.state.hiddenColumns.includes('collection_reference'),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{ width:140, overflowWrap: 'break-word', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.collection_reference && row.collection_reference !== '') ? row.collection_reference : ''}</span>
            } else {
              return row;
            }
          }
        },
        { 
          title: "Ordered By", 
          field: "uploader",
          cellStyle: {
             minWidth: 150,
            maxWidth: 150,
          },
          customSort: (a,b) => (a.uploader && a.uploader.first_name? a.uploader.first_name : '').localeCompare(b.uploader &&  b.uploader.first_name? b.uploader.first_name : ''),
          hidden: this.state.hiddenColumns.includes('order_by'),
          render: (row, type) => {
            if(type === 'row'){
              if(row.vendor_id && row.vendor_id == this.state.user.owner_info.application_company_id) {
                return (row && row.uploader && (row.uploader.application_company && row.uploader.application_company.company_name !== '')) ? <span style={{ width:140, overflowWrap: 'break-word', minHeight: 60}}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                        this.setState({
                          openPreviewDialog: true,
                          openPreviewDialogItem: row.id,
                        });
                    }
                  }
                }}                 
                >{row.uploader.application_company.company_name}</span> : '';
              } else {
                return (row && row.uploader && (row.uploader.first_name !== '' || row.uploader.last_name !== '')) ? <span style={{ width:140, overflowWrap: 'break-word', minHeight: 60}}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                        this.setState({
                          openPreviewDialog: true,
                          openPreviewDialogItem: row.id,
                        });
                    }
                  }
                }}                 
                >{(row.uploader.first_name? row.uploader.first_name: '') + ' ' + (row.uploader.last_name? row.uploader.last_name: '')}</span> : '';
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "Order Status",
          field: "order_status",
          cellStyle: {
            minWidth: 280,
            maxWidth: 280,    
          },
          sorting: false,
          customSort: (a,b) =>(a.order_status.status == "Not Assigned" ? "Pending" : a.order_status.status == "Assigned Pending" ? "On Hold": a.order_status.status).toString().toLowerCase().trim().localeCompare((b.order_status.status == "Not Assigned" ? "Pending" : b.order_status.status == "Assigned Pending" ? "On Hold": b.order_status.status).toString().toLowerCase().trim()),
          hidden: this.state.hiddenColumns.includes('order_status'),
          render: (row, type) => {
            let item = [];
            if(type === 'row'){
              item = this.state.tableStatus
              return <Box>
                    <Box>
                    {(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Status')) && (!row.vendor_id || row.vendor_id == this.state.user.owner_info.application_company_id) && this.isCollectionFailed(row) == false ?
                    <DropdownMenu 
                      isShouldEnable={true}
                      className={'status-btn ' + apiUtil.statusToClassName((row.order_status && row.order_status.status && row.order_status.status !== '') ?  row.order_status.status == "Not Assigned" ? "Pending" :  row.order_status.status == "Assign Pending" ? "On Hold"+'   ' :  row.order_status.status : '')}
                      text={(row && row.order_status && row.order_status.status) ? row.order_status.status == "Not Assigned" ? "Pending"+'   ': row.order_status.status == "Assign Pending" ? "On Hold"+'   ' : row.order_status.status+'   ' : ''}
                      rightIcon={<ArrowDownIcon />}
                      items={item}
                      onClick={(item) => {
                        if(row.drop_off_worker_id && row.drop_off_worker_id > 0 || item.text.toString().toLowerCase().trim() === 'cancelled' || item.text.toString().toLowerCase().trim() === 'pending' || item.text.toString().toLowerCase().trim() === 'on hold' || item.text.toString().toLowerCase().trim() === 'self collect'){
                          this.sendJsonData(true);
                          if((item.text.toString().toLowerCase().trim() === 'on hold' || item.text.toString().toLowerCase().trim() === 'self collect') && row.drop_off_worker_id) {
                            apiUtil.toast("Only Pending order(s) can be edited", "warning","error");
                            return;
                          }
                          let data = {
                            data: [
                              {
                                id: [ row.id ],
                                job_steps: (row.job_steps && row.job_steps.length > 0) ? row.job_steps.map(step => {
                                  step.job_step_id = step.id;
                                  if (item.text.toString().toLowerCase().trim() === "completed") {
                                    step.job_step_status_id = 3;
                                  } else {
                                    step.job_step_status_id = 1;
                                  }
                                  return step
                                }): row.job_steps,
                                order_status_id: item.id,
                                send_notification_to_customer: true,
                                drop_off_time_end: (item.text.toString().toLowerCase().trim() === "completed" || item.text.toString().toLowerCase().trim() === "failed") ? moment().format("h:mm a") : null,
                              }
                            ]
                          };

                          if(item.text.toString().toLowerCase().trim() === 'pending'){
                            data.data[0]['drop_off_worker_id'] = null;
                            data.data[0]['extra_worker_ids'] = null;
                            if (row.vendor_id == this.state.user.owner_info.application_company_id) {
                              data.data[0]['vendor_id'] = row.vendor_id;
                              let orderItem = apiUtil.customFilter(this.state.status, 'status', 'assigned to vendor')
                              data.data[0]['order_status_id'] = orderItem.id;
                            } else {
                              data.data[0]['vendor_id'] = null;
                            }
                          }

                          if(item.text.toString().toLowerCase().trim() === 'assigned to vendor' && row.drop_off_worker_id) {
                            apiUtil.toast("Order is already In Progress", "check_circle")
                            return;
                          }

                          this.callUpdateStatusApi(data, (newRow) => {
                            if(newRow){
                              let newData = apiUtil.updateRow(this.state.data, newRow, 'id');
                              window.location.reload();
                              // this.setState({
                              //   data: newData,
                              // });
                            }
                          });
                        } else {
                          apiUtil.toast('You must first assign a driver!', 'warning', 'error'); 
                        }
                      }}
                    /> : 
                    <DropdownMenu 
                      isShouldEnable={true}
                      className={'status-btn ' + apiUtil.statusToClassName((row.order_status && row.order_status.status && row.order_status.status !== '') ?  row.order_status.status == "Not Assigned" ? "Pending" :  row.order_status.status == "Assign Pending" ? "On Hold"+'   ' :  row.order_status.status : '')}
                      text={(row && row.order_status && row.order_status.status) ? row.order_status.status == "Not Assigned" ? "Pending"+'   ': row.order_status.status == "Assign Pending" ? "On Hold"+'   ' : row.order_status.status+'   ' : ''}
                      // rightIcon={<ArrowDownIcon />}
                      // items={this.state.tableStatus}
                    />
                     }        
                  </Box>
              </Box>;
          } else {
              return row;
            }
          }
        },
        // { 
        //   title: "POD", 
        //   field: "POD",
        //   cellStyle: {
        //     minWidth: 150,
        //     maxWidth: 150
        //   },
        //   hidden: this.state.hiddenColumns.includes('POD'),
        //   render: (row, type) => {
        //     if(type === 'row'){
        //       let jobStep = row.job_steps && row.job_steps[row.job_steps.length - 1]
        //       if(jobStep) {
        //       let signature_img = row.job_steps.length > 0 && jobStep.order_attempts && jobStep.order_attempts.length > 0 && jobStep.order_attempts[jobStep.order_attempts.length - 1].order_attempts_images.length > 0 ? jobStep.order_attempts[jobStep.order_attempts.length - 1].order_attempts_images.filter(dd => dd.is_signature == true) : []
        //       let proof_img =  row.job_steps.length > 0 && jobStep.order_attempts && jobStep.order_attempts.length > 0 && jobStep.order_attempts[jobStep.order_attempts.length - 1].order_attempts_images.length > 0 ? jobStep.order_attempts[jobStep.order_attempts.length - 1].order_attempts_images.filter(dd => dd.is_signature == false) : []
             
        //       return <div className='d-flex align-items-center justify-content-center'>
        //               {proof_img.length ? <div className="image-preview d-flex align-items-center justify-content-between w-100">
        //               <img src={proof_img[0]['image_url']} className="w-50" style={{margin: "auto"}}/>
        //               <span>
        //                 <img src={proof_img[0]['image_url']} className="hovered-image" style={{margin: "auto"}}/>
        //               </span> 
        //               {jobStep.order_attempts[jobStep.order_attempts.length - 1].order_attempts_images.length > 1 ? 
        //                 <FontAwesomeIcon icon={faPlusCircle} className=" fs-5 svg-primary"
        //                 onClick={(e) => {
        //                   e.stopPropagation();
        //                   e.preventDefault();
        //                   if((this.isCollectionFailed(row) == false || (this.isCollectionFailed(row) == true && row.job_type == "Collection"))) {
        //                     if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
        //                       this.setState({
        //                         openPreviewDialog: true,
        //                         openPreviewDialogItem: row.id,
        //                       });
        //                     }
        //                   }
        //                 }}/> : ''} </div> : signature_img.length ? <div className="image-preview d-flex align-items-center justify-content-between w-100">
        //                   <img src={signature_img[0]['image_url']} className="w-50" style={{margin: "auto"}}/>
        //                 <span>
        //                   <img src={signature_img[0]['image_url']} className="hovered-image" style={{margin: "auto"}}/>
        //                 </span>
        //                 {jobStep.order_attempts[jobStep.order_attempts.length - 1].order_attempts_images.length > 1 ? 
        //                   <FontAwesomeIcon icon={faPlusCircle} className=" fs-5 svg-primary"
        //                   onClick={(e) => {
        //                     e.stopPropagation();
        //                     e.preventDefault();
        //                     if((this.isCollectionFailed(row) == false || (this.isCollectionFailed(row) == true && row.job_type == "Collection"))) {
        //                       if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
        //                         this.setState({
        //                           openPreviewDialog: true,
        //                           openPreviewDialogItem: row.id,
        //                         });
        //                       }
        //                     }
        //                   }}/> : ""}
        //           </div> : '' }
        //       </div>
        //       }
        //     } else {
        //       return row;
        //     }
        //   }
        // },
        // { 
        //   title: "Reason for Failure", 
        //   field: "reason_for_failure",
        //   cellStyle: {
        //     minWidth: 150,
        //     maxWidth: 150
        //   },
        //   customSort: (a,b) => (a.job_steps.length > 0 && a.job_steps[0].order_attempts.length > 0 ? a.job_steps[0].order_attempts[0].reason: '').toString().toLowerCase().trim().localeCompare((b.job_steps.length > 0 && b.job_steps[0].order_attempts.length > 0 ? b.job_steps[0].order_attempts[0].reason: '').toString().toLowerCase().trim()),
        //   hidden: this.state.hiddenColumns.includes('reason_for_failure'),
        //   render: (row, type) => {
        //     if(type === 'row'){
        //       let jobStep = row.job_steps && row.job_steps[row.job_steps.length - 1]
        //       if(jobStep) {
        //       let failed_reason = row.job_steps.length > 0 && jobStep.order_attempts.length > 0  ? jobStep.order_attempts[jobStep.order_attempts.length - 1].reason : ''
        //       return row && row.order_status && row.order_status.status == "Failed" ? failed_reason : '';
        //       } 
        //     } else {
        //       return row;
        //     }
        //   }
        // },
        ... (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Address')) ?[{ 
          title: "Delivery Address", 
          field: "drop_off_address",
          cellStyle: {
            minWidth: 180,
            maxWidth: 180
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('delivery_address'),
          render: (row, type) => {
            if(type === 'row'){
              // return (row && row.drop_off_address && row.drop_off_address !== '') ? apiUtil.safeParse(row.drop_off_address) : '';
              return (row && row.drop_off_address && row.drop_off_address !== '') ?<span style={{ width:170, overflowWrap: 'break-word', display:'inline-block'}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              > {row.drop_off_address }</span>  : '';
            } else {
              return row;
            }
          }
        }] : [],
        { 
          title: "Postal Code", 
          field: "drop_off_postal_code",
          cellStyle: {
             minWidth: 120,
            maxWidth: 120,
          },
          sorting: false,
          customSort: (a,b) => Number(a.drop_off_postal_code ? a.drop_off_postal_code: '') - Number(b.drop_off_postal_code ? b.drop_off_postal_code: ''),
          hidden: this.state.hiddenColumns.includes('postal_code'),
          render: (row, type) => {
            if(type === 'row'){
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.drop_off_postal_code && row.drop_off_postal_code !== '') ? apiUtil.safeParse(row.drop_off_postal_code) : ''}</span>
            } else {
              return row;
            }
          }
        },
        ...(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Delivery Time')) ?[{ 
          title: "Between", 
          field: "drop_off_time_planned",
          cellStyle: {
            minWidth: 120,
            maxWidth: 120,
         },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('time_slot'),
          render: (row, type) => {
            if(type === 'row'){
              let drop_from_time = row && row.drop_off_time_planned && row.drop_off_time_planned !== '' ? row.drop_off_time_planned.split("-") : [];
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{drop_from_time.length > 0 && row.drop_off_time_planned != '9:00 - 18:00' ? drop_from_time[0] : ''}</span>
            } else {
              return row;
            }
          }
        }, 
        { 
          title: "And", 
          field: "drop_off_time_planned",
          cellStyle: {
            minWidth: 120,
            maxWidth: 120,
         },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('time_slot'),
          render: (row, type) => {
            if(type === 'row'){
              let drop_from_time = row && row.drop_off_time_planned && row.drop_off_time_planned !== '' ? row.drop_off_time_planned.split("-") : [];
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{drop_from_time.length > 0 && row.drop_off_time_planned != '9:00 - 18:00' ? drop_from_time[1] : ''}</span>
            } else {
              return row;
            }
          }
        }] : [],
        // ...(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Driver') ||
        //     this.state.currentRole == 'Ops Admin' ||
        //     this.state.currentRole == 'Finance Admin' ||
        //     this.state.currentRole == 'BD Admin') ? [{ 
        //   title: "Driver-Partner", 
        //   field: "driver_partner",
        //   cellStyle: {
        //     minWidth: 150,
        //     maxWidth: 150
        //   },
        //   customSort: (a,b) => (a.drop_off_worker ? a.drop_off_worker.first_name : '').toString().toLowerCase().trim().localeCompare((b.drop_off_worker ? b.drop_off_worker.first_name : '').toString().toLowerCase().trim()),
        //   hidden: this.state.hiddenColumns.includes('driver_partner'),
        //   render: (row, type) => {
        //     if(type === 'row'){
        //       if(row.drop_off_worker_id && row.drop_off_worker_id > 0 && row.drop_off_worker){
                
        //         row.workerName = row.drop_off_worker.first_name +" "+ row.drop_off_worker.last_name;
        //       }
        //       if(row.vendor_id && row.vendor_id != null){
        //         row.vendorName = ( row.vendor && row.vendor.company_name != null ? row.vendor.company_name : "") ;
        //       }
            
        //       return row.vendor_id ? row.vendor_id != this.state.user.owner_info.application_company_id ? row.vendorName : row.workerName : row.workerName  
        //     } else {
        //       return row;
        //     }
        //   }
        // }] : [],
        // ...(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Man Power')||
        //     this.state.currentRole == 'Ops Admin' ||
        //     this.state.currentRole == 'Finance Admin' ||
        //     this.state.currentRole == 'BD Admin') ? [{ 
        //   title: "Driver-Assistant", 
        //   field: "extra_workers[0].first_name",
        //   cellStyle: {
        //     minWidth: 150,
        //     maxWidth: 150
        //   },
        //   customSort: (a,b) => (a.extra_workers && a.extra_workers.length > 0 && a.extra_workers[0].first_name ? a.extra_workers[0].first_name : '').toString().toLowerCase().trim().localeCompare((b.extra_workers && b.extra_workers.length > 0 && b.extra_workers[0].first_name ? b.extra_workers[0].first_name  : '').toString().toLowerCase().trim()),
        //   hidden: this.state.hiddenColumns.includes('driver_partner'),
        //   render: (row, type) => {
        //     if(type === 'row'){
        //       let label = '';
        //       let manpowerName = (row.extra_workers && row.extra_workers.length > 0) ? row.extra_workers[0] : null;

        //       if(manpowerName){
        //         label = ((manpowerName.first_name && manpowerName.first_name !== '') ? manpowerName.first_name : '') + ' ' + ((manpowerName.last_name && manpowerName.last_name !== '') ? manpowerName.last_name : '');
        //       }

        //       row.manpowerName = label;
        //       return row.manpowerName;
              
        //     } else {
        //       return row;
        //     }
        //   }
        // }] : [],
        // ...(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Company')) ? [{ 
        //   title: "Client Company", 
        //   field: "recipent_company",
        //   cellStyle: {
        //     minWidth: 150,
        //     maxWidth: 150
        //   },
        //   hidden: this.state.hiddenColumns.includes('recipent_company'),
        //   customSort: (a,b) => (a.customer ? a.customer.company_name : '').toString().toLowerCase().trim().localeCompare((b.customer ? b.customer.company_name : '').toString().toLowerCase().trim()),
        //   render: (row, type) => {
        //     if(type === 'row'){
        //       return <span style={{ width:130, overflowWrap: 'break-word', display:'inline-block'}}>{(row && row.customer && row.customer.company_name !== '') ? apiUtil.safeParse(row.customer.company_name) : ''} </span>;
        //       // return (row && row.drop_off_description && row.drop_off_description !== '') ?<span style={{ width:350, overflowWrap: 'break-word', display:'inline-block'}}> {row.drop_off_description }</span>  : '';
        //     } else {
        //       return row;
        //     }
        //   }
        // }] : [],
        { 
          title: "Department", 
          field: "department",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          hidden: this.state.hiddenColumns.includes('department'),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{ width:130, overflowWrap: 'break-word', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}  
              >{(row && row.department && row.department.name ) ? apiUtil.safeParse(row.department.name) : ''}</span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Recipient's Name", 
          field: "drop_off_contact_name",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('recipient_name'),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{ width:130, overflowWrap: 'break-word', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.drop_off_contact_name ) ? apiUtil.safeParse(row.drop_off_contact_name) : ''}</span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Company", 
          field: "drop_off_name",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('company'),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{ width:130, overflowWrap: 'break-word', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.drop_off_name ) ? apiUtil.safeParse(row.drop_off_name) : ''}</span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Contact No.", 
          field: "drop_off_contact_no",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('recipient_contact'),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{ width:130, overflowWrap: 'break-word', display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.drop_off_contact_no) ? apiUtil.safeParse(row.drop_off_contact_no) : ''} </span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Alternative Contact", 
          field: "drop_off_alternate_contact",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('alternate_contact'),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{ width:130, overflowWrap: 'break-word', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.drop_off_alternate_contact) ? apiUtil.safeParse(row.drop_off_alternate_contact) : ''} </span>;
            } else {
              return row;
            }
          }
        },
        { 
          title: "Recipient Email", 
          field: "notification_email",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('recipient_email'),
          render: (row, type) => {
            if(type === 'row'){
              return <span style={{ width:120, overflowWrap: 'break-word', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.notification_email ) ? apiUtil.safeParse(row.notification_email) : ''}</span>;
            } else {
              return row;
            }
          }
        },
        ...(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Driver')) ?[{ 
          title: "Item Description", 
          field: "drop_off_description",
          cellStyle: {
            minWidth: 200,
            maxWidth: 200
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('item_description'),
          render: (row, type) => {
            if(type === 'row'){
              return <span className='none-backgroud-color' style={{ width:180, overflowWrap: 'break-word', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.drop_off_description && row.drop_off_description !== '') ? apiUtil.safeParse(row.drop_off_description) : ''}</span>;
              // return (row && row.drop_off_description && row.drop_off_description !== '') ?<span style={{ width:350, overflowWrap: 'break-word', display:'inline-block'}}> {row.drop_off_description }</span>  : '';
            } else {
              return row;
            }
          }
        }] : [],
        { 
          title: "XS", 
          field: "xs_packages",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.order_packages.length > 0 && a.order_packages.filter(dd => dd.package_id == 1).length > 0 ? a.order_packages.filter(dd => dd.package_id == 1)[0].package_quantity: '') - Number(b.order_packages.length > 0 && b.order_packages.filter(dd => dd.package_id == 1).length > 0 ? b.order_packages.filter(dd => dd.package_id == 1)[0].package_quantity: ''),
          hidden: this.state.hiddenColumns.includes('xs_packages'),
          render: (row, type) => {
            if(type === 'row'){             
              if(!row.order_packages || row.order_packages.length === 0){
                return <div className="view-normal packages-error"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}              
                ></div>
              } else {
                let pack = row.order_packages ? row.order_packages.filter(dd => dd.package_id == 1) : []
                return <span 
                className={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details') && this.isCollectionFailed(row) == false ? "linkable-place" : ""}
                style={{ width:150, overflowWrap: 'break-word', display:'flex',height: 50,alignItems: 'center',justifyContent: 'center'}} 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}> {pack.length > 0 ? pack[0].package_quantity : ''} </span>
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "S", 
          field: "s_packages",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.order_packages.length > 0 && a.order_packages.filter(dd => dd.package_id == 2).length > 0 ? a.order_packages.filter(dd => dd.package_id == 2)[0].package_quantity: '') - (b.order_packages.length > 0 && b.order_packages.filter(dd => dd.package_id == 2).length > 0 ? b.order_packages.filter(dd => dd.package_id == 2)[0].package_quantity: ''),
          hidden: this.state.hiddenColumns.includes('s_packages'),
          render: (row, type) => {
            if(type === 'row'){
              if(!row.order_packages || row.order_packages.length === 0){
                return <div className="view-normal packages-error"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}              
                ></div>
              } else {
                let pack = row.order_packages ? row.order_packages.filter(dd => dd.package_id == 2) : []
                return <span 
                className={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details') && this.isCollectionFailed(row) == false ? "linkable-place" : ""}
                style={{ width:150, overflowWrap: 'break-word', display:'flex',height: 50,alignItems: 'center',justifyContent: 'center'}} 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}> {(pack.length > 0) ? pack[0].package_quantity: ''} </span>
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "M", 
          field: "m_packages",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.order_packages.length > 0 && a.order_packages.filter(dd => dd.package_id == 3).length > 0 ? a.order_packages.filter(dd => dd.package_id == 3)[0].package_quantity: '') - Number(b.order_packages.length > 0 && b.order_packages.filter(dd => dd.package_id == 3).length > 0 ? b.order_packages.filter(dd => dd.package_id == 3)[0].package_quantity: ''),
          hidden: this.state.hiddenColumns.includes('m_packages'),
          render: (row, type) => {
            if(type === 'row'){
              if(!row.order_packages || row.order_packages.length === 0){
                return <div className="view-normal packages-error"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}              
                ></div>
              } else {
                let pack = row.order_packages ? row.order_packages.filter(dd => dd.package_id == 3) : []
                return <span 
                className={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details') && this.isCollectionFailed(row) == false ? "linkable-place" : ""}
                style={{ width:150, overflowWrap: 'break-word', display:'flex',height: 50,alignItems: 'center',justifyContent: 'center'}} 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}> {(pack.length > 0) ? pack[0].package_quantity: ''} </span>
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "L", 
          field: "l_packages",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.order_packages.length > 0 && a.order_packages.filter(dd => dd.package_id == 4).length > 0 ? a.order_packages.filter(dd => dd.package_id == 4)[0].package_quantity: '') - Number(b.order_packages.length > 0 && b.order_packages.filter(dd => dd.package_id == 4).length > 0 ? b.order_packages.filter(dd => dd.package_id == 4)[0].package_quantity: ''),
          hidden: this.state.hiddenColumns.includes('l_packages'),
          render: (row, type) => {
            if(type === 'row'){
              if(!row.order_packages || row.order_packages.length === 0){
                return <div className="view-normal packages-error"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}              
                ></div>
              } else {
                let pack = row.order_packages ? row.order_packages.filter(dd => dd.package_id == 4) : []
                return <span 
                className={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details') && this.isCollectionFailed(row) == false ? "linkable-place" : ""}
                style={{ width:150, overflowWrap: 'break-word', display:'flex',height: 50,alignItems: 'center',justifyContent: 'center'}} 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}> {(pack.length > 0) ? pack[0].package_quantity: ''} </span>
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "Oversized", 
          field: "oversized_packages",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.order_packages.length > 0 && a.order_packages.filter(dd => dd.package_id == 6).length > 0 ? a.order_packages.filter(dd => dd.package_id == 6)[0].package_quantity: '') - Number(b.order_packages.length > 0 && b.order_packages.filter(dd => dd.package_id == 6).length > 0 ? b.order_packages.filter(dd => dd.package_id == 6)[0].package_quantity: ''),
          hidden: this.state.hiddenColumns.includes('oversized_packages'),
          render: (row, type) => {
            if(type === 'row'){
              if(!row.order_packages || row.order_packages.length === 0){
                return <div className="view-normal packages-error"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}              
                ></div>
              } else {
                let pack = row.order_packages ? row.order_packages.filter(dd => dd.package_id == 6) : []
                return <span 
                className={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details') && this.isCollectionFailed(row) == false ? "linkable-place" : ""}
                style={{ width:150, overflowWrap: 'break-word', display:'flex',height: 50,alignItems: 'center',justifyContent: 'center'}} 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}> {(pack.length > 0) ? pack[0].package_quantity: ''} </span>
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "Pallets", 
          field: "pallets",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.order_packages.length > 0 && a.order_packages.filter(dd => dd.package_id == 5).length > 0 ? a.order_packages.filter(dd => dd.package_id == 5)[0].package_quantity: '') - Number(b.order_packages.length > 0 && b.order_packages.filter(dd => dd.package_id == 5).length > 0 ? b.order_packages.filter(dd => dd.package_id == 5)[0].package_quantity: ''),
          hidden: this.state.hiddenColumns.includes('pallets'),
          render: (row, type) => {
            if(type === 'row'){
              if(!row.order_packages || row.order_packages.length === 0){
                return <div className="view-normal packages-error"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}              
                ></div>
              } else {
              let pack = row.order_packages ? row.order_packages.filter(dd => dd.package_id == 5) : []
                return <span 
                className={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details') && this.isCollectionFailed(row) == false ? "linkable-place" : ""}
                style={{ width:150, overflowWrap: 'break-word', display:'flex',height: 50,alignItems: 'center',justifyContent: 'center'}} 
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {                    
                      this.setState({
                        preview_detail: row,
                        preview_index: index,                                   
                      }, () => {
                        this.setState({
                          openPackageDialog: true,
                        });  
                      });  
                    }
                  }
                }}> {(pack.length > 0) ? pack[0].package_quantity: ''} </span>
              }
            } else {
              return row;
            }
          }
        },
        { 
          title: "Depalletization Request", 
          field: "depalletization_request",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => (a.package_info && JSON.parse(a.package_info).depalletization_request ? JSON.parse(a.package_info).depalletization_request : '').toString().toLowerCase().trim().localeCompare((b.package_info && JSON.parse(b.package_info).depalletization_request ? JSON.parse(b.package_info).depalletization_request : '').toString().toLowerCase().trim()),
          hidden: this.state.hiddenColumns.includes('depalletization_request'),
          render: (row, type) => {
            if(type === 'row'){
              let package_info = JSON.parse(row.package_info)
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }} 
              >{(package_info && package_info.depalletization_request) ? package_info.depalletization_request  : ''}</span>
             } else {
              return row;
            }
          }
        },
        { 
          title: "Size in cm(L + W + H)", 
          field: "size_lwh",
          cellStyle: {
            minWidth: 170,
            maxWidth: 170
          },
          sorting: false,
          customSort: (a,b) => Number(a.package_info &&  JSON.parse(a.package_info).size_l_w_h  && !isNaN(JSON.parse(a.package_info).size_l_w_h) ? JSON.parse(a.package_info).size_l_w_h : '') - Number(b.package_info && JSON.parse(b.package_info).size_l_w_h && !isNaN(JSON.parse(b.package_info).size_l_w_h)? JSON.parse(b.package_info).size_l_w_h : ''),
          hidden: this.state.hiddenColumns.includes('size_lwh'),
          render: (row, type) => {
            if(type === 'row'){
              let package_info = JSON.parse(row.package_info)
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(package_info && package_info.size_l_w_h) ? package_info.size_l_w_h : ''}</span>
            } else {
              return row;
            }
          }
        },
        { 
          title: "Weight (KG)", 
          field: "weight",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.package_info &&  JSON.parse(a.package_info).weight  && !isNaN(JSON.parse(a.package_info).weight) ? JSON.parse(a.package_info).weight : '') - Number(b.package_info && JSON.parse(b.package_info).weight && !isNaN(JSON.parse(b.package_info).weight)? JSON.parse(b.package_info).weight : ''),
          hidden: this.state.hiddenColumns.includes('weight'),
          render: (row, type) => {
            if(type === 'row'){
              let package_info = JSON.parse(row.package_info)
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(package_info && package_info.weight) ? package_info.weight : ''}</span>
            } else {
              return row;
            }
          }
        },
        { 
          title: "Waiting Time", 
          field: "waiting_time",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.package_info &&  JSON.parse(a.package_info).waiting_time  && !isNaN(JSON.parse(a.package_info).waiting_time) ? JSON.parse(a.package_info).waiting_time : '') - Number(b.package_info && JSON.parse(b.package_info).waiting_time && !isNaN(JSON.parse(b.package_info).waiting_time)? JSON.parse(b.package_info).waiting_time : ''),
          hidden: this.state.hiddenColumns.includes('waiting_time'),
          render: (row, type) => {
            if(type === 'row'){
              let package_info = JSON.parse(row.package_info)
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(package_info && package_info.waiting_time) ? package_info.waiting_time : ''}</span>
             } else {
              return row;
            }
          }
        },
        { 
          title: "Additional Manpower", 
          field: "no_of_movers",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.package_info &&  JSON.parse(a.package_info).no_of_movers  && !isNaN(JSON.parse(a.package_info).no_of_movers) ? JSON.parse(a.package_info).no_of_movers : '') - Number(b.package_info && JSON.parse(b.package_info).no_of_movers && !isNaN(JSON.parse(b.package_info).no_of_movers)? JSON.parse(b.package_info).no_of_movers : ''),
          hidden: this.state.hiddenColumns.includes('no_of_movers'),
          render: (row, type) => {
            if(type === 'row'){
              let package_info = JSON.parse(row.package_info)
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(package_info && package_info.no_of_movers) ? package_info.no_of_movers : ''}</span>
            } else {
              return row;
            }
          }
        },
        { 
          title: "Price", 
          field: "amount",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.amount ? a.amount : '') - Number(b.amount ? b.amount : ''),
          hidden: this.state.hiddenColumns.includes('price'),
          render: (row, type) => {
            if(type === 'row'){
              if (row.vendor_id == this.state.user.owner_info.application_company_id) {
                return <span
                style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                        this.setState({
                          openPreviewDialog: true,
                          openPreviewDialogItem: row.id,
                        });
                    }
                  }
                }}       
                >{(row && row.vendor_payout && row.vendor_payout !== '') ? parseFloat(row.vendor_payout).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}</span>

              } 
              return <span
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.amount && row.amount !== '') ? parseFloat(row.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}</span>
              
            } else {
              return row;
            }
          }
        },
        { 
          title: "Vendor Payout", 
          field: "vendor_payout",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          customSort: (a,b) => Number(a.vendor_payout ? a.vendor_payout : '') - Number(b.vendor_payout ? b.vendor_payout : ''),
          hidden: this.state.hiddenColumns.includes('vendor_payout'),
          render: (row, type) => {
            if(type === 'row'){
              if ( row.vendor_id == this.state.user.owner_info.application_company_id || !row.vendor_id) {
                  return <span
                  style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if(this.isCollectionFailed(row) == false) {
                      if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                          this.setState({
                            openPreviewDialog: true,
                            openPreviewDialogItem: row.id,
                          });
                      }
                    }
                  }}                  
                  >-</span>
              } 
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.vendor_payout && row.vendor_payout !== '') ? parseFloat(row.vendor_payout).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}</span>

            } else {
              return row;
            }
          }
        },
        ...(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Driver Payout')) ?[{ 
          title: "Driver Payout", 
          field: "driver_payout",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('driver_payout'),
          customSort: (a,b) => Number(a.driver_payout ? a.driver_payout : '') - Number(b.driver_payout ? b.driver_payout : ''),
          render: (row, type) => {
            if(type === 'row'){
              if((row.vendor_id && row.vendor_id != this.state.user.owner_info.application_company_id) || !row.drop_off_worker_id ) {
                return <span
                style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  if(this.isCollectionFailed(row) == false) {
                    if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                        this.setState({
                          openPreviewDialog: true,
                          openPreviewDialogItem: row.id,
                        });
                    }
                  }
                }}                
                >-</span>
              }
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.driver_payout && row.driver_payout !== '') ? parseFloat(row.driver_payout).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ''}</span>
            } else {
              return row;
            }
          }
        }] : [],
        { 
          title: "Notes to Driver-Partner", 
          field: "driver_notes",
          cellStyle: {
            minWidth: 150,
            maxWidth: 150
          },
          sorting: false,
          hidden: this.state.hiddenColumns.includes('notes_to_driver'),
          render: (row, type) => {
            if(type === 'row'){
              return <span
              style={{display: 'flex',alignItems: 'center',justifyContent: 'center', minHeight: 60}}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if(this.isCollectionFailed(row) == false) {
                  if (this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')) {
                      this.setState({
                        openPreviewDialog: true,
                        openPreviewDialogItem: row.id,
                      });
                  }
                }
              }}              
              >{(row && row.driver_notes && row.driver_notes !== '') ? apiUtil.safeParse(row.driver_notes) : ''}</span>
             } else {
              return row;
            }
          }
        }
      ]}
    />

    }else {
      return <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'75vh'}>
        <CircularProgress size={35} />
      </Box>
    }

    
  }

  handleTabChange = (event, newValue) => {
    this.setState({
        tabValue: newValue
    })
  }

  callCreateApi = (row, callback = null) => {
    const { accessToken } = this.context;
    this.setState({
      isLoading: true,
    }, ()=> {
      ldsApi.create('duplicate/orders/multiple', row, accessToken)
      .then((result) => {
        apiUtil.parseResult(result, (data) => {
          if(callback){
            callback(data);
          }
        }, (error, type) => {
          this.setState({
            isLoading: false,
          }, () => {
            apiUtil.toast(
              error,
              "check_circle"
            );
          });
        });
    });
    })

  }

  callUpdateApi = (id, row, callback = null,customLoad = false) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      ldsApi.update('orders/' + id, row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {

            if(customLoad == false) {
              apiUtil.toast(
                "Successfully Updated",
                "check_circle"
              )
              this.setState({
                isLoading: false,
              }, () => {
                if(callback){
                  callback(data);
                }
              });
            } else {
              if(callback){
                callback(data);
              }               
            }
          }, (error, type) => {
            apiUtil.toast(
              error,
              "check_circle"
            )
            this.setState({
              isLoading: false,
            }, () => {
            });
          });
      });
    });
  }

  callUpdateDoApi = (row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      ldsApi.update('/allocation/do_number', row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            apiUtil.toast(
              "Successfully Updated",
              "check_circle"
            )
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(data);
              }
            });
          }, (error, type) => {
            apiUtil.toast(
              error,
              "check_circle"
            )
            this.setState({
              isLoading: false,
            }, () => {
            });
          });
      });
    });
  }
  /* DIALOG */
  customDialog = () => {
    return <CustomDialog 
      open={this.state.openDialog}
      title={'Delete'}
      onClose={() => {
        this.setState({
          openDialog: false,
          openDialogItem: null,
        });
      }}
      onOk={() => {
        let row = this.state.openDialogItem;
        this.callDeleteApi(row, () => {
          this.setState({
            openDialog: false,
            openDialogItem: null,
          }, () => {
            this.loadStatusApi();
            this.callReadApi(this.refTableSearch.current.state.value);
            apiUtil.toast('Successfully Deleted', 'check_circle');
          });
        });
      }}
    >
      <Box>Are you sure you want to delete?</Box>
    </CustomDialog>
  }

    /* DIALOG */
    customDoDialog = () => {
      return <CustomDialog 
        open={this.state.openDoDialog}
        title={'Duplicate Order'}
        onClose={() => {
          this.setState({
            openDoDialog: false,
            DoDialogOrder: null,
          });
          this.DoDialogOrder = null;
        }}
        onOk={() => {
          let row = this.DoDialogOrder;
          if ( row['0'].do_number != null) {
            row['0'].do_number = row['0'].do_number.trim()
            this.callCreateApi(row, () => {
              this.setState({
                openDoDialog: false,
                DoDialogOrder: null,
              }, () => {
                this.DoDialogOrder = null;
                this.callInitApis();
              });
            });
        }
        }}
      >
        <Box className="do_warning text-center"><FontAwesomeIcon icon={faWarning} style={{color: "#ff9966"}}/> Please unique D.O Number for Duplicate Pick Up Order</Box>
        {this.DoDialogOrder && this.DoDialogOrder.orders && this.DoDialogOrder.orders[0].do_number && <Box className="do_warning my-2 p-2 text-center"><FontAwesomeIcon icon={faWarning} style={{color: "#ff9966"}}/> D.O number can't be blank</Box>}
        <input className="form-control" placeholder="Eg. ABCD001" onChange={(e)=>{
            let doDialogOrder = this.DoDialogOrder;
            doDialogOrder['0'].do_number = e.target.value;
            ['id','order_number','order_status','extra_workers','uploader','reference_no'].forEach(e => delete doDialogOrder['0'][e]);
            doDialogOrder['0'].drop_off_date = moment(doDialogOrder['0'].drop_off_date).format("YYYY-MM-DD");
            doDialogOrder['0'].collection_reference = null;
            this.DoDialogOrder = doDialogOrder
            // this.setState({toUpdate:doDialogOrder})
        }}/>
      </CustomDialog>
    }

    customWarnDialog = () => {
      return <CustomDialog 
        open={this.state.openWarnDialog}
        title={'Warning'}
        onClose={() => {
          this.setState({
            openWarnDialog: false,
          });
        }}
        onOk={() => {
          this.props.history.push(this.state.route);
        }}
      >
        <Box className="do_warning text-center">
          <FontAwesomeIcon icon={faWarning} style={{color: "#ff9966"}} className="fs-3"/>
          <div className="fs-6 font-medium p-2 pb-0" style={{color: "#ff9966"}}>Pick Up without Delivery order is exist!!</div>
          <div className="fs-6 font-medium p-2 pb-0" style={{color: "#ff9966"}}>Are you sure?</div>
        </Box>
      </CustomDialog>
    }
  
 
  Updatedtoast = () => {
    apiUtil.toast('Successfully Updated', 'check_circle');
  }



  previewDialog = () => {
    if(this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Details')){
    return <CustomDialog 
      open={this.state.openPreviewDialog}
      title={'Order Details'}
      maxWidth={'lg'}
      padding={'0'}
      hideButtons={true}
      onClose={() => {
        this.setState({
          openPreviewDialog: false,
          openPreviewDialogItem: null,
        });
      }}
    >
      <JobPreviewDialog
        id={this.state.openPreviewDialogItem}
        onClose={() => {
          this.setState({
            openPreviewDialog: false,
            openPreviewDialogItem: null,
          });
        }}
        onSave={(data) => {
          if(data) {
            apiUtil.toast('Successfully Updated', 'check_circle');
            this.callInitApis()
          }
          this.setState({
            openPreviewDialog: false,
            openPreviewDialogItem: null,
          });
        }}
      />
      <OrderDetailForm 
        orderId={this.state.openPreviewDialogItem}
        onSaving={() => {
          this.setState({
            savingLoad: true
          });              
        }}
        onSave={() => {
          this.setState({
            savingLoad: false,
            savedLoad: true   
          }, () => {
            this.callReadApi();
            this.setState({
              openPreviewDialog: false,
              openPreviewDialogItem: null,
            });          
          })
        }}
        onClose={()=>{
          this.setState({
            openPreviewDialog: false,
            openPreviewDialogItem: null,
          });        
        }}
    /> 
    </CustomDialog>
    }
  }
  
  setDistinctDarkColors = (count) => {
    const colors = [];
  
    for (let i = 0; i < count; i++) {
      const hue = Math.floor((360 / count) * i); // evenly spaced hues
      const saturation = 70; // keep strong color
      const lightness = 30;  // dark color
  
      colors.push(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
    }
  
    this.setState({
      randomColor: colors 
    });
  }
  
  sendJsonData = (refresh=false) => {
      const { accessToken, sendJsonDataGlobal } = this.context;
      if(refresh) {
        sendJsonDataGlobal(true);
        return;        
      }     
      
      let startDate = moment(this.state.startDate).format(apiUtil.getDefaultDateFormat());
      let endDate = startDate;
      let param = {
        page: 1,
        take: 1000,
        start_date: startDate,
        end_date: endDate,
        order_status: this.state.order_status,
        vendor_id: false,
        non_groupped_order: true,
        allocation_step: 1,
        sort: "latest",
        is_optimise: true
      };
      
      // if(order)
          
      ldsApi.read('allocation/orders', param, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            if(data.result.length > 0) {  
              let jsonOrders = [];
              data.result.forEach(obj => {
                jsonOrders = [...jsonOrders,...obj.orders] 
              });
              try {
                localStorage.setItem("jsonOrders", JSON.stringify(jsonOrders));

                sendJsonDataGlobal(false,(success,created_pickup = null,response_data = null) => {
                    if(success) {
                       this.setState({
                         activeStep: 3,
                       }); 
                      const total_load_volume_list = {};
                      this.callReadApi('',(orders_data) => {
                        if(orders_data.length > 0) {
                          this.setDistinctDarkColors(orders_data.length);   
                        }

                        if(response_data) {
                          response_data.final_routes.forEach(route => {
                            total_load_volume_list[route.assignedVehicle] = route.totalLoadVolume;
                          });
                        }
                        this.setState({
                          batch_pickup_ids: created_pickup ? created_pickup.saved_orders.filter(o => o.is_batch_pickup).map( o => o.id) : [],
                          total_load_volume_list: response_data && response_data.final_routes.length > 0 ? total_load_volume_list : {}
                        }); 
                      });

                    } else {
                      if(this.state.activeStep == 2){
                        apiUtil.toast('Something Wrong!', 'check_circle');
                        this.setState({
                          isLoading: false,
                          activeStep: 1
                        });
                      }
                    }                        
                });
      
              } catch (e) {
                if (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError') {
                  apiUtil.toast('Order data too many. Can not procedure.', 'check_circle');
                  this.setState({
                    activeStep: 1,
                    isLoading: false,
                  }); 
                }
              }                
            } else {
              apiUtil.toast('There is no orders.', 'check_circle');
              this.setState({
                activeStep: 1,
                isLoading: false,
              }); 
            }   
          }, (error, type) => {
            apiUtil.toast(error, 'check_circle');
            this.setState({
              activeStep: 1,
              isLoading: false,
            });        
          });
      });
  }


  handleChange = (val) => this.setState({value: val});
  customSearch = () => {
    return <div>
            <Row className="px-4">
            <Col>
                <Card className="overflow-hidden box-shadow-search">
                    <div className="row border-0 d-flex justify-content-start align-items-center max-block-lg">
                      <div className="col-xs-12 col-md-6 d-flex col-md-auto align-items-center justify-self-start me-auto">
                        <div className="row d-flex">
                            <div className="col-12 col-xs-12 col-lg-8">
                              <input placeholder="Enter Job Number, Company Name, etc" className="border-0 border-bottom p-2 m-4 max-height-input" 
                              value={this.state.searched}
                              onChange={(e)=> {
                                this.setState({
                                  searched : e.target.value
                              })
                              }}
                               onEnter={(e) => {
                                this.pages = 1
                                this.callReadApi()
                              }}
                              />
                              </div>
                              <div className="col-12 col-xs-12 col-lg-4 d-flex align-items-center">
                              <Button className="upload-style-search max-height-btn my-4"
                                onClick={(e) => {
                                  this.pages = 1
                                  this.callReadApi()
                                }}
                              ><FontAwesomeIcon icon={faMagnifyingGlass} /> Search</Button>
                                {(this.state.searched !== '' ) && <Box mb={1}>
                                  <IconButton
                                  onClick={e => {
                                    this.setState({
                                      searched: ''
                                    }, () =>{
                                      this.callReadApi()
                                    })
                                    
                                  }}
                                  ><span  data-tooltip="clear search" data-tooltip-conf="danger"><img src={Filterimg} width="25px" /></span></IconButton>
                                  </Box>
                                }
                              </div>
                              </div>
                              </div>
                              <div className="col-xs-12 col-md-6 d-flex col-md-auto align-items-center justify-self-end justify-content-end ms-auto">
                                <div className="row d-flex justify-content-end p-4">
                                     <Button className="upload-style-search max-height-btn my-4 btn btn-primary"
                                     onClick={e=>{  
                                       this.sendJsonData();
                                     }}
                                     >Allocate</Button>
                                </div>
                                <div className="row d-flex justify-content-end p-4">
                                   <Button className="delete-style max-xs-width-control-1019 m-2"
                                   disabled={this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Job Delete') ? false : true }
                                   onClick={e=>{  
                                   
                                     let selected_orders = this.state.data.filter(obj => obj.is_selected == true)
                                     if(selected_orders.length > 0) {
                                       this.setState({
                                         openBulkDeleteDialog : true,
                                       })
                                     }
                                   }}
                                   >Bulk Delete</Button>
                                </div>
                            </div>
                          
                        </div>
                </Card> 
            </Col>
            </Row>
            </div>
  }
  
  packageDialog = () => {
    return <CustomDialog2 
      open={this.state.openPackageDialog}
      maxWidth={'xs'}
      padding={'0'}
      onClose={() => {
        this.setState({
          openPackageDialog: false
        });
      }}
      hideCancelButtons={true}
      hideOkButtons={true}
      hideHeader={true}
    >    
      <Container fluid>
        <Row>
          <Col className="fs-5 fw-bold col-12">
            Number of Packages:
          </Col>
          <Col className="py-2 col-12 justify-content-center align-items-center d-flex">
            <div className="col-9 justify-content-center">
              <span className="fw-bold fs-5">
                XS
              </span>
            </div>
            <div className="ps-2 col-3 justify-content-center">
              <CustomInput
                  placeholder={'5'}
                  className="number-input-show-border"
                  type={'number'}
                  inputProps={{min: 0}}
                  pattern="^-?[0-9]\d*\.?\d*$"

                  value={this.state.preview_detail.order_packages.filter(dd => dd.package_id == 1).length > 0 ? this.state.preview_detail.order_packages.filter(dd => dd.package_id == 1)[0].package_quantity : ''}
                  onPaste={(e) => {
                    if(/^\d+$/.test(e.clipboardData.getData('Text')) == false ){
                      e.preventDefault()
                      return false;
                    }
                  }}
                  onKeyDown={(e) => {
                    if(e.key == "e" || e.key == "E" || e.key == "-" || e.key == ".") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    let index = this.state.preview_detail.order_packages.findIndex(dd => dd.package_id === 1);
                    if (e.target.value >= 1 && e.target.value !== '') {
                       if(index === -1) {
                        let pack = {
                          package_id: 1,
                          name: 'XS',
                          package_quantity: e.target.value
                        }
                        this.state.preview_detail.order_packages.push(pack)
                       } else {
                          this.state.preview_detail.order_packages[index].package_quantity = e.target.value
                          delete this.state.preview_detail.order_packages[index]["delete"]
                       }
                    } else {
                      if (index !== -1 && this.state.preview_detail.order_packages[index]["id"] > 0 ) {
                        this.state.preview_detail.order_packages[index]["delete"] = true                   
                      }      
                      if(this.state.preview_detail.order_packages[index]) {
                        this.state.preview_detail.order_packages[index]["package_quantity"] = '0'     
                      }                  
                    }

                    this.setState({
                      preview_detail: this.state.preview_detail
                    });
                  }}
              />
            </div>          
          </Col>
          <Col className="py-2  col-12 justify-content-center align-items-center d-flex">
            <div className="col-9 justify-content-center">
              <span className="fw-bold fs-5">
                S
              </span>
              <span className="fw-bold" style={{fontSize: 14,color: '#dadfe2',marginLeft: 20}}>
                &lt;5kg, L + W + H &lt; 80cm
              </span>
            </div>
            <div className="ps-2 col-3 justify-content-center">
              <CustomInput
                   placeholder={'5'}
                   className="number-input-show-border"
                   type={'number'}
                   inputProps={{min: 0}}
                   pattern="^-?[0-9]\d*\.?\d*$"
                   value={this.state.preview_detail.order_packages.filter(dd => dd.package_id == 2).length > 0 ? this.state.preview_detail.order_packages.filter(dd => dd.package_id == 2)[0].package_quantity : ''}
                   onPaste={(e) => {
                     if(/^\d+$/.test(e.clipboardData.getData('Text')) == false ){
                       e.preventDefault()
                       return false;
                     }
                   }}
                   onKeyDown={(e) => {
                     if(e.key == "e" || e.key == "E" || e.key == "-" || e.key == ".") {
                       e.preventDefault();
                     }
                   }}
                   onChange={(e) => {
                     let index = this.state.preview_detail.order_packages.findIndex(dd => dd.package_id === 2);
                     if (e.target.value >= 1 && e.target.value !== '') {
                       if(index === -1) {
                         let pack = {
                           package_id: 2,
                           name: 'S',
                           package_quantity: e.target.value
                         }
                         this.state.preview_detail.order_packages.push(pack)
                        } else {
                         this.state.preview_detail.order_packages[index]["package_quantity"] = e.target.value
                         delete this.state.preview_detail.order_packages[index]["delete"]
                        }
                     } else {
                       if (index !== -1 && this.state.preview_detail.order_packages[index]["id"] > 0 ) {
                         this.state.preview_detail.order_packages[index]["delete"] = true                
                       }
                       if(this.state.preview_detail.order_packages[index]) {
                         this.state.preview_detail.order_packages[index]["package_quantity"] = '0'
                       }
                     }
                       
                     this.setState({
                         preview_detail: this.state.preview_detail
                     });
                   }}
               />
            </div>          
          </Col>
          <Col className="py-2 col-12 justify-content-center align-items-center d-flex">
            <div className="col-9 justify-content-center">
              <span className="fw-bold fs-5">
                M
              </span>
              <span className="fw-bold" style={{fontSize: 14,color: '#dadfe2',marginLeft: 20}}>
                &lt;15kg, L + W + H &lt; 120cm
              </span>
            </div>
            <div className="ps-2 col-3 justify-content-center">
              <CustomInput
                placeholder={'3'}
                type={'number'}
                inputProps={{min: 0}}
                className="number-input-show-border"
                pattern="^-?[0-9]\d*\.?\d*$"
                value={this.state.preview_detail.order_packages.filter(dd => dd.package_id == 3).length > 0 ? this.state.preview_detail.order_packages.filter(dd => dd.package_id == 3)[0].package_quantity : ''}
                onPaste={(e) => {
                  if(/^\d+$/.test(e.clipboardData.getData('Text')) == false ){
                    e.preventDefault()
                    return false;
                  }
                }}
                onKeyDown={(e) => {
                  if(e.key == "e" || e.key == "E" || e.key == "-" || e.key == ".") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  let index = this.state.preview_detail.order_packages.findIndex(dd => dd.package_id === 3);
                  if (e.target.value >= 1 && e.target.value !==  '' ) {
                    if(index === -1) {
                      let pack = {
                        package_id: 3,
                        name: 'M',
                        package_quantity: e.target.value
                      }
                      this.state.preview_detail.order_packages.push(pack)
                     } else {
                      this.state.preview_detail.order_packages[index]["package_quantity"] = e.target.value
                      delete this.state.preview_detail.order_packages[index]["delete"]
                     }
                  } else {
                    if (index !== -1 && this.state.preview_detail.order_packages[index]["id"] > 0 ) {
                      this.state.preview_detail.order_packages[index]["delete"] = true                 
                    } 
                    if(this.state.preview_detail.order_packages[index]) {
                      this.state.preview_detail.order_packages[index]["package_quantity"] = '0'
                    }
                  }
                    
                  this.setState({
                      preview_detail: this.state.preview_detail
                  });
                }}
              />
            </div>          
          </Col>
          <Col className="py-2 col-12 justify-content-center align-items-center d-flex">
            <div className="col-9 justify-content-center">
              <span className="fw-bold fs-5">
                L
              </span>
              <span className="fw-bold" style={{fontSize: 14,color: '#dadfe2',marginLeft: 20}}>
                &lt;25kg, L + W + H &lt; 180cm
              </span>
            </div>
            <div className="ps-2 col-3 justify-content-center">
              <CustomInput
                placeholder={'3'}
                type={'number'}
                inputProps={{min: 0}}
                className="number-input-show-border"
                pattern="^-?[0-9]\d*\.?\d*$"
                value={this.state.preview_detail.order_packages.filter(dd => dd.package_id == 4).length > 0 ? this.state.preview_detail.order_packages.filter(dd => dd.package_id == 4)[0].package_quantity : ''}
                onPaste={(e) => {
                  if(/^\d+$/.test(e.clipboardData.getData('Text')) == false ){
                    e.preventDefault()
                    return false;
                  }
                }}
                onKeyDown={(e) => {
                  if(e.key == "e" || e.key == "E" || e.key == "-" || e.key == ".") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  let index = this.state.preview_detail.order_packages.findIndex(dd => dd.package_id === 4);
                  if (e.target.value >= 1 && e.target.value !== '' ) {
                    if(index === -1) {
                      let pack = {
                        package_id: 4,
                        name: 'L',
                        package_quantity: e.target.value
                      }
                      this.state.preview_detail.order_packages.push(pack)
                     } else {
                      this.state.preview_detail.order_packages[index]["package_quantity"] = e.target.value
                      delete this.state.preview_detail.order_packages[index]["delete"]
                     }
                  } else {
                    if (index !== -1 && this.state.preview_detail.order_packages[index]["id"] > 0 ) {
                      this.state.preview_detail.order_packages[index]["delete"] = true                 
                    } 
                    if(this.state.preview_detail.order_packages[index]) {
                      this.state.preview_detail.order_packages[index]["package_quantity"] = '0'
                    }
                  }

                  this.setState({
                      preview_detail: this.state.preview_detail
                  });
                }}
              />
            </div>          
          </Col>
          <Col className="py-2 col-12 justify-content-center align-items-center d-flex">
            <div className="col-9 justify-content-center">
              <span className="fw-bold fs-5">
                Oversized
              </span>
            </div>
            <div className="ps-2 col-3 justify-content-center">
              <CustomInput
                placeholder={'3'}
                type={'number'}
                inputProps={{min: 0}}
                className="number-input-show-border"
                pattern="^-?[0-9]\d*\.?\d*$"
                value={this.state.preview_detail.order_packages.filter(dd => dd.package_id == 6).length > 0 ? this.state.preview_detail.order_packages.filter(dd => dd.package_id == 6)[0].package_quantity : ''}
                onPaste={(e) => {
                  if(/^\d+$/.test(e.clipboardData.getData('Text')) == false ){
                    e.preventDefault()
                    return false;
                  }
                }}
                onKeyDown={(e) => {
                  if(e.key == "e" || e.key == "E" || e.key == "-" || e.key == ".") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  let index = this.state.preview_detail.order_packages.findIndex(dd => dd.package_id === 6);
                  if (e.target.value > 0 && e.target.value !== '' ) {
                    if(index === -1) {
                      let pack = {
                        package_id: 6,
                        name: 'Oversized Package',
                        package_quantity: e.target.value
                      }
                      this.state.preview_detail.order_packages.push(pack)
                     } else {
                      this.state.preview_detail.order_packages[index]["package_quantity"] = e.target.value
                      delete this.state.preview_detail.order_packages[index]["delete"]
                     }
                  } else {
                    if (index !== -1 && this.state.preview_detail.order_packages[index]["id"] > 0 ) {
                      this.state.preview_detail.order_packages[index]["delete"] = true
                    } 
                    if(this.state.preview_detail.order_packages[index]) {
                      this.state.preview_detail.order_packages[index]["package_quantity"] = '0'
                    }
                     
                  }
                    
                  this.setState({
                      preview_detail: this.state.preview_detail
                  });
                }}
              />
            </div>          
          </Col>
          <Col className="py-2 col-12 justify-content-center align-items-center d-flex">
            <div className="col-9 justify-content-center">
              <span className="fw-bold fs-5">
                Pallets
              </span>
            </div>
            <div className="ps-2 col-3 justify-content-center">
              <CustomInput
                  placeholder={'3'}
                  type={'number'}
                  inputProps={{min: 0}}
                  className="number-input-show-border"
                  pattern="^-?[0-9]\d*\.?\d*$"
                  value={this.state.preview_detail.order_packages.filter(dd => dd.package_id == 5).length > 0 ? this.state.preview_detail.order_packages.filter(dd => dd.package_id == 5)[0].package_quantity : ''}
                  onPaste={(e) => {
                    if(/^\d+$/.test(e.clipboardData.getData('Text')) == false ){
                      e.preventDefault()
                      return false;
                    }
                  }}
                  onKeyDown={(e) => {
                    if(e.key == "e" || e.key == "E" || e.key == "-" || e.key == ".") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    let index = this.state.preview_detail.order_packages.findIndex(dd => dd.package_id === 5);
                    if (e.target.value > 0 && e.target.value !== '' ) {
                      if(index === -1) {
                        let pack = {
                          package_id: 5,
                          name: 'Pallets',
                          package_quantity: e.target.value
                        }
                        this.state.preview_detail.order_packages.push(pack)
                       } else {
                        this.state.preview_detail.order_packages[index]["package_quantity"] = e.target.value 
                        delete this.state.preview_detail.order_packages[index]["delete"]
                       }
                    } else {
                      if (index !== -1 && this.state.preview_detail.order_packages[index]["id"] > 0 ) {
                        this.state.preview_detail.order_packages[index]["delete"] = true
                      } 
                      if(this.state.preview_detail.order_packages[index]) {
                        this.state.preview_detail.order_packages[index]["package_quantity"] = '0'
                      }                      
                       
                    }
                      
                    this.setState({
                        preview_detail: this.state.preview_detail
                    });
                  }}
              />
            </div>          
          </Col>
        </Row>
      </Container>
      <div className="justify-content-center p-4">
        <div className="d-flex justify-content-center">
          <Button variant="secondary" className="mx-4 px-4 py-2 border-delete-b" onClick={() => {
                this.setState({
                  openPackageDialog: false,
                });
              }}>
                Cancel
          </Button>
          <Button variant="primary" className="mx-4 px-4 py-2" style={{borderRadius:'50px'}}
            disabled={!this.state.preview_detail.order_packages.filter( obj => obj.package_quantity > 0).length > 0}
            onClick={() => {
              let order = this.state.preview_detail;
              this.setState({
                savingLoad: true
              }, () => {
                this.sendJsonData(true);
                this.callUpdateApi(order.id,order,() => {
                  this.setState({
                      savingLoad:false,
                      openPackageDialog: false,
                      preview_detail: null,
                      preview_index: null,
                  }, () => {
                    this.setState({
                      savedLoad: true    
                    }, () => {
                      this.callReadApi();    
                    });                    
                  });
                });                  
              })
            }}
            >
            Submit
          </Button>
        </div>
      </div>
    </CustomDialog2>
  }
  
  handleNext = () => {
    this.setState((prevState) => ({
      activeStep: Math.min(prevState.activeStep + 1, prevState.steps.length - 1)
    }),() => {
      if(this.state.activeStep == 0 || this.state.activeStep == 1) {
        this.callReadApi();
      } else if ( this.state.activeStep == 2) {
        this.setState({
          isLoading: true
        },() => {
          this.sendJsonData();
        });
      } else if (this.state.activeStep == 3) {
        let payload = {}
        
        if(!this.state.data.filter((obj) => obj.worker_id != '').length > 0) {
          window.location.href = "/dashboard";   
        }
        let incre = 0;
        this.state.data.map( (obj,index) => {
          if(obj.worker_id != '') {
            incre += 1;
            payload = {
              order_status_id: apiUtil.customFilter(this.state.status, 'status', 'assigned').id,
              drop_off_worker_id: obj.worker_id,
              selected_do_number: obj.orders.filter( o => o.job_type == 'Collection').map( o => o.do_number).join(',')
            }
            this.callDriverAssignApi(payload, (result) => {
              if(this.state.data.filter((f) => f.worker_id != '').length == incre){
                apiUtil.toast("Successfully Updated", 'warning', 'error');
                this.setState({
                  activeStep: 4,
                });
                setTimeout(() => {
                  window.location.href = "/dashboard"  
                },2000);  
              }                
            }); 

          }            
                   
        });
        
        
      }          
    });
  };

  handleBack = () => {
    this.setState((prevState) => ({
      activeStep: Math.max(prevState.activeStep - 1, 0)
    }),() => {
      if(this.state.activeStep == 0 || this.state.activeStep == 1) {
          
        this.setState({
          search_text: ''    
        },() => {      
          this.callReadApi();        
        });

      }          
    });
  };
  
  getTotalPackageGroupBy = (data) => {
    const packageNames = {
      1: "XS",
      2: "S",
      3: "M",
      4: "L",
      5: "Pallets",
      6: "Oversized",
    };
    
    // Step 1: Sum up all quantities by package_id
    const totals = data
    .flatMap(group => group.orders)
    .flatMap(order => order.order_packages)
    .filter(p => p.package_quantity !== 0)
    .reduce((acc, pkg) => {
      acc[pkg.package_id] = (acc[pkg.package_id] || 0) + pkg.package_quantity;
      return acc;
    }, {});

    // Step 2: Build result following the packageNames sequence
    const result = Object.entries(packageNames)
    .filter(([id]) => totals[id]) // only include if exists
    .map(([id, name]) => ` ${totals[id]}${name}`)
    .join(",");
    
    return result;
  }
  
  getTotalPackage = (order) => {
    const packageNames = {
      1: "XS",
      2: "S",
      3: "M",
      4: "L",
      5: "Pallets",
      6: "Oversized",
    };    

    const result = order.order_packages
      .filter( p => p.package_quantity != 0)
      .reduce((acc, pkg) => {
        const name = packageNames[pkg.package_id] || `Unknown-${pkg.package_id}`;
        acc[name] = (acc[name] || 0) + (pkg.package_quantity || 0);
        return acc;
      }, {});
    
    const packageSummary = Object.entries(result)
      .map(([name, qty]) => ` ${qty}${name}`)
      .join(",");
      
    return packageSummary;
  }
  
  getMissingPackagesCount = (is_search=false) => {
    if(is_search) {
      const result = this.state.oldData.flatMap(obj => obj.orders.filter(order => !order.order_packages || order.order_packages.length === 0))
      this.setState({
        data: result.length > 0 ? [{
          company_name: 'Filter Results',
          postal_code: 'Filter Results',
          open: true,
          orders: result
        }] : []
      });
    } else {
      const missingOrdersCount = this.state.data.reduce((acc, obj) => {
        return acc + obj.orders.filter(order => order.order_packages.length === 0).length;
      }, 0);    
      return missingOrdersCount;    
    }
  }
  
  getNotDefaultTimeWindowCount = (is_search=false) => {
    if(is_search) {
      const result = this.state.oldData.flatMap(obj => obj.orders.filter(order => order.drop_off_time_planned != '9:00 - 18:00'))
      this.setState({
        data: result.length > 0 ? [{
          company_name: 'Filter Results',
          postal_code: 'Filter Results',
          open: true,
          orders: result
        }] : []
      });         
    } else {
      const orderCount = this.state.data.reduce((acc, obj) => {
        return acc + obj.orders.filter(order => order.drop_off_time_planned != '9:00 - 18:00').length;
      }, 0);    
      return orderCount;   
    }    
  }
  
  changeTimeFormat = (time) => {
    let time_list = time.split(' - ')
    
    return moment(time_list[0], "HH:mm").format("h:mma")+' - '+moment(time_list[1], "HH:mm").format("h:mma");
    
  }

  render() {
    const { activeStep, steps} = this.state;
    // Calculate progress percentage (stops at each circle)
    const progressPercent =
      activeStep === 0 ? 0 : activeStep === 1 ? 36 : activeStep === 2 ? 62 : activeStep === 3 ? 88 : (activeStep / (steps.length - 1)) * 100;
    return <Container
        fluid
        style={{
          overflowY: 'auto',
          margin: "0px auto",
          padding: "60px 50px",
          backgroundColor: '#fff'
        }}
        className="allocation-optimization"
      >
        {/* Stepper */}
        <div className="stepper-container">
          <div className="base-line" />
          <div
            className="progress-line"
            style={{
              width: `${progressPercent}%`,
            }}
          />

          {steps.map((step, index) => (
            <div key={index} className="step-item">
              <div
                className={`step-circle ${
                  index < activeStep ? "active" : ""
                }`}
              >
                {index < activeStep ? <StepTrue /> : <span>{step.number}</span>}
              </div>
              <div className="step-label">{step.label}</div>
            </div>
          ))}
        </div>
        {activeStep == 0 || activeStep == 1 ? <Row>
           <Col xs={12} md={7} lg={9} className="mb-4">
             <div style={{backgroundColor: '#F8F9FA',padding: '5px 12px',borderRadius: 8}}>
               <FontAwesomeIcon icon={faMagnifyingGlass} style={{padding: '0px 10px'}}/>
               <input placeholder="Search Tracker numbers, DO numbers, delivery addresses, client companies..." className="border-0 p-2"
               style={{backgroundColor: '#F8F9FA',width: '87%',outline: 'none'}}
               value={this.state.search_text}
               onChange={e => {
                 let value = e.target.value;
                 this.setState({
                   search_text:value,
                 },() => {
                   let search_value = this.state.search_text.normalize('NFKC').trim().toLowerCase();

                   if(search_value != '') {
                     let result = this.state.oldData.flatMap( obj => obj.orders.filter( o => o.order_number.trim().toLowerCase().includes(search_value) || o.do_number.normalize('NFKC').trim().toLowerCase().includes(search_value) || o.drop_off_address.normalize('NFKC').trim().toLowerCase().includes(search_value) || o.job_type.trim().toLowerCase().includes(search_value) || (o.drop_off_postal_code && o.drop_off_postal_code.trim().toLowerCase().includes(search_value)) || (o.company_name && o.company_name.normalize('NFKC').trim().toLowerCase().includes(search_value)) || (o.drop_off_description && o.drop_off_description.normalize('NFKC').trim().toLowerCase().includes(search_value)) || (o.driver_notes && o.driver_notes.normalize('NFKC').trim().toLowerCase().includes(search_value)) || (o.customer && (o.customer.departments.filter( d => d.name && d.name.normalize('NFKC').trim().toLowerCase().includes(search_value)).length > 0 || o.customer.company_name.normalize('NFKC').trim().toLowerCase().includes(search_value)))) || (obj.company_name && obj.company_name != '' && obj.company_name.normalize('NFKC').trim().toLowerCase().includes(search_value)) || (obj.postal_code && obj.postal_code != '' && obj.postal_code.trim().toLowerCase().includes(search_value)));
                     this.setState({
                       data: result.length > 0 ? [{
                         company_name: 'Search Results',
                         postal_code: 'Search Results',
                         open: true,
                         orders: result
                       }] : []
                     });  
                   } else {
                     this.setState({
                       data: this.state.oldData 
                     });
                   }                       
                 })
               }}
                />    
             </div>              
           </Col>
           <Col xs={12} md={5} lg={3} className="allocation-calendar-input mb-4">
             <div className="custom-input-component">
               <CustomInput
                 name="hidden-date"
                 color={'secondary'}
                 type={"date"}
                 value={this.state.startDate}
                 onChange={(e) => {                   
                   localStorage.setItem('allocation_date', e.target.value);
                   this.sendJsonData(true);
                   this.setState({
                     startDate: e.target.value
                   },() => {
                     this.callReadApi();
                   })
                 }}
                 style={{ opacity: 0, position: "absolute", pointerEvents: "none" }}
               />
               <CustomInput
                 className={'no-margin'}
                 disabled={this.state.isLoading}
                 color={'secondary'}
                 type={"text"}
                 value={moment(this.state.startDate).format(apiUtil.getAllocationDateFormat())}
                 readOnly
                 endAdornment={(obj) => {
                   return <Box
                       onClick={(e) => {
                           e.stopPropagation();
                           e.preventDefault();
                       }}
                   >
                       <BlueCalendar />
                   </Box>
                 }}
                 onClick={() => document.getElementById("hidden-date-id").showPicker?.()}
               />
             </div>
           </Col>
           <Col xs={12} className="mb-xs-0 mb-lg-4 mb-md-4">
             <div className="filter-container">
               <span>Filters:</span><CustomButton color="primary" className="allocation-button" onClick={() => this.setState({data: this.state.oldData})}><Box>All ({this.state.total_orders_count})</Box></CustomButton><CustomButton className="allocation-button" style={{backgroundColor: '#E7F5FF'}} onClick={() => this.getMissingPackagesCount(true)}><BoxPlus /><Box style={{color: "#017BFE"}}>Missing Packages ({this.state.missingPackageCount})</Box></CustomButton><CustomButton className="allocation-button" style={{backgroundColor: "#F8F9FA"}} onClick={ () => this.getNotDefaultTimeWindowCount(true)}><GreyClock /><Box style={{color: '#6C757D'}}>Time Windows ({this.state.timeWindowCound})</Box></CustomButton><CustomButton className="allocation-button no-padding" style={{backgroundColor: 'unset',pointerEvents: 'none'}}><Box style={{color: '#000'}}>Showing {this.state.data.reduce((acc, obj) => acc + obj.orders.length, 0)} out of {this.state.total_orders_count} jobs</Box></CustomButton>
             </div>
           </Col>
        </Row> : ''}
        <Row>
        {this.state.activeStep == 0 || this.state.activeStep == 1 ? <Col style={{minHeight: 400}}>
          {this.state.isLoading ? <Card>
            <div className="p-4 d-flex justify-content-center align-items-center text-center" style={{minHeight: 400}}>
              <CircularProgress size={35} />
            </div> 
          </Card> : 
          this.state.data && this.state.data.length > 0 ? 
          this.state.data.map((dd, index) => {
            return <Card className="mb-4" style={{border: 'none'}}>
                    <div className="d-flex justify-content-between align-items-center mb-3 pb-2" style={{borderBottom: "1px solid #E9ECEF"}}>
                      <div className="d-flex justify-content-start align-items-center max-xs-width-control-1019 flex-column flex-xl-row">
                        <FontAwesomeIcon style={{fontSize: 24,cursor: 'pointer'}} icon={dd.open ? faChevronDown : faChevronUp} className="me-2" 
                        onClick={() => {
                          this.state.data[index].open = !dd.open;   
                          this.setState({
                            data: this.state.data   
                          });
                        }}
                        />
                        <span style={{fontSize: 24}} className="font-medium fs-5">{this.state.activeStep == 1 ? (dd.postal_code != "" && dd.postal_code != null) ? dd.postal_code : "(Not Specified)" : (dd.company_name && dd.company_name != "" && dd.company_name != null) ? dd.company_name.replace(/\s/g, '\u00A0') : "(Not Specified)"}</span>
                        <div className="orders-count">
                          <span>{dd.orders.length} Jobs</span>
                        </div>
                      </div>
                    </div>
                    {dd.open ? this.customTable(dd.orders, index) : ''}
                  </Card>
          }) :
          <Card className="cd-shadow p-4 text-center"><span className="do_warning fs-6"><FontAwesomeIcon icon={faWarning} style={{color: "#ff9966"}}/>  There is no available Allocation Data!!</span></Card>
          }
        </Col>
        :
        this.state.activeStep == 2 ? <Col>
          {this.state.isLoading ? <Card>
            <div className="p-4 d-flex justify-content-center align-items-center text-center" style={{minHeight: 400,flexDirection: 'column'}}>
              <CircularProgress size={35} />
              <span className="fs-6 mt-4">Allocation Microsite is running</span>
            </div> 
          </Card> : ''}
        </Col>
        :
        <Col>
          {this.state.isLoading ? <Card>
            <div className="p-4 d-flex justify-content-center align-items-center text-center" style={{minHeight: 400,flexDirection: 'column'}}>
              <CircularProgress size={35} />
            </div> 
          </Card>
          :
          <Row>
          {this.state.data.length > 0 ? 
          this.state.data.map((obj,index) => {
            return <Col className="group-name-container" xs={12} md={6} lg={4}>
                {this.state.grantedAccess.isPermissionActionAllowed( this.state.currentRole, 'Driver') ||
                this.state.currentRole == 'Ops Admin' ? <Box>
                  <CustomAutosuggest 
                    style={{borderRadius: 8,border: '1px solid #017BFE'}}
                    disabled = {this.state.currentRole != "Super Admin Role" ? true: false}
                    className={'no-margin z-index-autoSuggest mb-3'}
                    items={this.state.workerItems}
                    placeholder={'Assign Driver'}
                    value={obj.worker_name}
                    showArrow={true}
                    onChange={(value) => {
                      let status = '';
                      let data = '';
                      let orderStatusItem = '';
                      if (value) {
                        obj.worker_name = value.label;
                        obj.worker_id = value.value;                       
                      } else {
                        obj.worker_name = '';
                        obj.worker_id = ''; 
                      }
                      
                    }}
                    onSearch={(value, e) => {
                      e.showNewSuggestions(this.state.workerItems.filter(dd => dd.label && (dd.label.includes(value) || dd.label.toLowerCase().includes(value) || dd.label.toLowerCase().includes(value.toLowerCase()))));
                    }}
                    onClick={(value, e) => {
                      e.showNewSuggestions(this.state.workerItems.filter(dd => dd.label && (dd.label.includes(value) || dd.label.toLowerCase().includes(value) || dd.label.toLowerCase().includes(value.toLowerCase()))));
                    }}
                  />
                </Box> : ''}
                <div className="text-center pt-3 pb-3" style={{backgroundColor: obj.group_name == 'Assign to Vendor' ? '#000' : this.state.randomColor[index],borderTopLeftRadius: 10,borderTopRightRadius: 10}}>
                  <span style={{fontSize: 24,color: '#fff'}}>{obj.group_name}</span>
                </div>
                <div className="orders-container" style={{padding: 16,boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.1)",borderRadius: 10}}>
                  <div className={obj.group_name == 'Assign to Vendor' ? 'assign-to-vendor' : ''}>
                      {obj.group_name != 'Assign to Vendor' ? <div className="vehicle-summary" style={{padding: 16,borderRadius: 10,border: "2px solid #000",marginBottom: 16}}>
                      <div style={{display: 'flex',flexWrap: 'wrap',justifyContent: 'space-Between',alignItems: 'center'}}>
                        <span style={{flex: '0 0 auto',width: 70,marginBottom: 10}}>Deliveries</span>
                        <div style={{flex: '0 0 auto',width: 211,marginBottom: 10,display: 'flex',justifyContent: 'space-between'}}>
                          <div className="pickup-box">
                            <span>Pick Up: {obj.orders.filter( o => o.job_type == 'Collection').length}</span>
                            <img src={PickUpArrow} width="16px" />
                          </div>
                          <div className="delivery-box">
                            <span>Drop Off: {obj.orders.filter( o => o.job_type == 'Delivery').length}</span>
                            <img src={DropOffArrow} width="16px" />
                          </div>
                        </div>
                      </div>
                      <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center',marginBottom: 10}}>
                        <span>Total Load Volume</span>
                        <span>{this.state.total_load_volume_list && this.state.total_load_volume_list[obj.group_name] ? this.state.total_load_volume_list[obj.group_name] : '-'}</span>
                      </div>
                      <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
                        <span>Number of Packages</span>
                        <div style={{padding: "4px 8px",backgroundColor: "#CED4DA",borderRadius: 8,display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                          <span style={{maxWidth: 176}}>{this.getTotalPackageGroupBy([obj])}</span>                     
                          <img src={BlackBox} width="16px" style={{marginLeft: 6}} />
                        </div>
                      </div>
                    </div> : ''}
                    {obj.orders.map((order,index) => {
                      return <div className="job-container" style={{padding: 16,borderRadius: 10,border: order.job_type == 'Collection' ? "2px solid #017BFE" : "2px solid #ECA60F",marginBottom:16}}>
                        <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center',marginBottom: 16}}>
                          <span style={{fontSize: 12,width: order.job_type == 'Collection' ? '50%' : '56%'}}>{order.do_number}</span>
                          {order.job_type == 'Collection' ? <div className="pickup-box">
                            <span style={{color: "#017BFE"}}>{this.state.batch_pickup_ids.includes(order.id) ? "Batched Pick Up" : "Pick Up"}</span><img src={PickUpArrow} width="16px" />
                          </div>
                          :
                          <div className="delivery-box">
                            <span>Drop Off</span><img src={DropOffArrow} width="16px" />
                          </div>}                        
                        </div>
                        <span style={{fontSize: 16, fontWeight: '500',display:'block'}}>{order.drop_off_address} {order.drop_off_postal_code ? '('+order.drop_off_postal_code+')' : ''}</span>    
                        <div className={(order.drop_off_time_planned && order.drop_off_time_planned != '9:00 - 18:00') ? "has-diff-time-window job-footer-container" : "job-footer-container"} style={{alignItems: 'center',display: 'flex',flexWrap: 'wrap',gap: 16,marginTop: 16}}>
                          {order.job_type == 'Collection' ? <div className={"pickup-box"} style={{flex: '0 0 auto'}}>
                            <span>{this.getTotalPackage(order)}</span><img src={PickUpBox} width="16px" /><img src={PickUpArrow} width="16px" />
                          </div>
                          :
                          <div className={"delivery-box"} style={{flex: '0 0 auto'}}>
                            <span>{this.getTotalPackage(order)}</span><img src={DeliveryBox} width="16px" /><img src={DropOffArrow} width="16px" />
                          </div>}  
                          {(order.drop_off_time_planned && order.drop_off_time_planned != '9:00 - 18:00') ? <div className="red-time-window-box">
                            <img src={RedClock} width="16px" style={{marginRight: 6}} /><span>{this.changeTimeFormat(order.drop_off_time_planned.replace(/(\r\n|\n|\r)/gm, ""))}</span>  
                          </div> : ''}
                        </div>                      
                      </div>
                    })}
                  </div>
                </div>
            </Col>            
          }) : ''}
          </Row>}
        </Col>          
        }
        </Row>

        {/* Navigation Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
            padding: "0 20px"
          }}
        >
          <Button
            variant="link"
            onClick={this.handleBack}
            disabled={activeStep === 0 || activeStep === 3}
            className="back-btn"
          >
            <FontAwesomeIcon icon={faChevronLeft} className="me-2" />
            Back
          </Button>
          <div style={{display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
            { this.state.savingLoad ?
            <CustomButton
              className="allocation-footer-btn me-4"
              style={{backgroundColor: '#F8F9FA'}}
            >
              <img src={SavingLoad} width="16px" className="me-2"/>
              <Box style={{color: '#017BFE'}}>Saving</Box>
            </CustomButton> : ''}
            
            {this.state.savedLoad ?
            <CustomButton
              className="allocation-footer-btn me-4"
              style={{backgroundColor: '#F8F9FA !important'}}
            >
              <SavedLoad className="me-2" />
              <Box style={{color: '#017BFE'}}>Saved</Box>
            </CustomButton> : ''}
            
            {this.state.errorLoad ?
            <CustomButton
              className="allocation-footer-btn me-4"
              style={{backgroundColor: '#F8F9FA !important'}}
            >
              <ErrorLoad className="me-2" />
              <Box style={{color: '#EF4343'}}>Error</Box>
            </CustomButton> : ''}
            <CustomButton
              className="allocation-footer-btn"
              onClick={this.handleNext}
              disabled={this.state.isLoading || !this.state.oldData.length > 0}
              style={{backgroundColor: '#017BFE'}}
            >
              <Box style={{color: '#fff'}}>{activeStep == 3 ? "Complete" : "Next"}</Box>
              <FontAwesomeIcon icon={faChevronRight} className="ms-2" />
            </CustomButton>
          </div>
        </div>
        {this.previewDialog()}
        {(this.state.isLoading == false && this.state.openPackageDialog) && this.packageDialog()}
      </Container>;
  }
}

export default Allocation;